import React, {useState, useEffect } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import firebase from '../../firebase/config'
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

function History() {
    
    const history = useHistory()
    let data = useLocation();
    const [user, setUser] = useState({})

    const ordenesList = [
        "Seleccionar orden:",
        "Hemograma completo",
        "Medicina Nuclear",
        "PET",
        "Panel básico metabólico: Electrolitos, glucosa, nitrógeno de urea, creatinina",
        "Perfil hepático: Bilirrubina, total y directa, AST, LDH",
        "Perfil lipídico: Colesterol, LDL, HDL, Triglicérido",
        "Perfil renal: Nitrógeno de urea, creatinina, ácido úrico, proteína total, albúmina-globulina calcio, glucosa",
        "Perfil triode: TSH, T3, T4",
        "Rayos X (Radiología)",
        "Resonancia Magnética",
        "Tomografía",
        "Ultrasonido",
        "Urinálisis completo"
    ]

    let medicamentos = [
        "Ac. salicílico + lidocaina + mercurio ii amida",
        "Acarbosa",
        "Aceite de limón",
        "Aceite de soya", 
        "alfa tocofenol", 
        "ácido ascórbico", 
        "biotina", 
        "caseinato de calcio", 
        "fosfato de calcio",
        "pantotenato de calcio",
        "calcitriol",
        "carnitina", 
        "cobre", 
        "citrato de colina", 
        "cromo", 
        "fitomenadiona", 
        "acido fólico", 
        "glicéridos de ácidos grasos",
        "Acemanano",
        "Acepromacina",
        "Acetato",
        "Acetato de alfatocoferol (vitamina e)",
        "Acetazolamida",
        "Acetilcisteína",
        "Aciclovir",
        "Acido acético",
        "Acido acético + ácido bórico + aceite de eucaliptus + aloe vera",
        "Acido acetilsalicilico (aspirina)",
        "Acido acetohidroxamico",
        "Acido ascórbico (vitamina c)",
        "Acido clavulánico + amoxicilina + prednisolona",
        "Acido dehidrocólico",
        "Acido tranexámico",
        "Acido ursodesoxicólico",
        "Acido valproico",
        "Acidos grasos omega + ácido linoleico + minerales y vitaminas",
        "Acidos grasos omega 3 (epa y dha)",
        "Acidos grasos omega 3 (epa y dha) y omega 6 (la y gla)",
        "Acidos grasos omega 3 (epa) y omega 6 (la y gla)",
        "Acidos grasos omega 3 + d. glucosamina + condroitin sulfato a + gluconato de cobre + gluconato de zinc + selenito de sodio + vitamina e",
        "Acidos grasos omega 3/6 + vitamina e",
        "Acitretina",
        "ACTH hipofisiario",
        "Adrenalina (epinefrina)",
        "Agentes biocidas y surfactantes",
        "Agua bidestilada",
        "Alantoina + bálsamo peruano artificial + aceite de hígado de bacalao",
        "Albendazol",
        "Albendazol + praziquantel",
        "Alcohol diclorobencilo + 2-bromo, 2-nitropane, 1.3diol + fluido de biosulfuro + sedaplat richter",
        "Alopurinol",
        "Alprazolam",
        "Alquitrán + ácido salicilico + sulfuros",
        "Aluminio hidroxido gel",
        "Aluminio magnesio hidróxido",
        "Amikacina",
        "Aminofilina",
        "Amiodarona",
        "Amitraz",
        "Amitraz + cipermetrina",
        "Amitriptilina",
        "Amonio cuaternario",
        "Amonio cuaternario (cloruro de benzalconio)",
        "Amonio cuaternario (superquat)",
        "Amonio cuaternario + aldehido glutárico",
        "Amonio cuaternario + detergentes no-ionicos",
        "Amonio cuaternario al 50%",
        "Amoxicilina + acido clavulánico",
        "Amoxicilina + gentamicina",
        "Amoxicilina inyectable",
        "Amoxicilina oral",
        "Ampicilina",
        "Apomorfina",
        "Aromas repelentes inocuos",
        "Astemizol",
        "Atenolol",
        "Atp + aspartato + selenito + vit. b12",
        "Atracurio besilato",
        "Atropina + papaverina",
        "Atropina sulfato",
        "Atropina sulfato (oftálmico)",
        "Avena sativa + miel + hierro + propoleo + vitaminas: b1, b2, b6, b12, c",
        "Azatioprina",
        "Azitromicina",
        "Azul de metileno (cloruro de metiltionina)",
        "Bacitracina + neomicina + óxido de zinc",
        "Bencetimida",
        "Bencilpenicilina procaínica, neomicina, metilprednisona",
        "Betaglucanos",
        "Betametasona",
        "Betametasona + lidocaina + oxido de zinc",
        "Bicarbonato de sodio",
        "Bifonazol",
        "Bifosfato de sodio + fosfato de sodio",
        "Bisacodilo",
        "Bismuto, Subsalicilato de",
        "Boldo + colina citrato + &nbsp;fitomenadiona + inositol pancreatina + sales biliares",
        "Bromelina",
        "Bromhexina",
        "Bromocriptina",
        "Bromuro de potasio",
        "Buscapina (escopolamina) + metamizol",
        "Buscapina (escopolamina,butilbromuro)",
        "Buserrelina (factor de liberación de GnRH)",
        "Buspirona",
        "Busulfano",
        "Butafosfano + vitamina b12",
        "Cacodilato+vitamina complejo b+aminoacidos",
        "Calcio + glucosa + magnesio + potasio cloruro + sodio cloruro + sodio lactato",
        "Calcio cloruro + potasio cloruro + sodio cloruro",
        "Calcio cloruro + potasio cloruro + sodio cloruro + sodio lactato",
        "Calcio fosfato dibasico dihidrato + calcio lactato pentahidrato + vitamina d3",
        "Calcio gluconato + magnesio cloruro + vitamina b1 + vitamina b2 + vitamina b6 + nicotinamida + pantotenato de calcio + ergocalciferol (vit. d2)",
        "Calcitonina sintetica de salmon",
        "Calcitriol (vitamina d)",
        "Caolin + pectina",
        "Captopril",
        "Carbamato (propoxur)",
        "Carbamato (propoxur) + flumetrina",
        "Carbamato (propoxur) + sulfanilamida + coumaphos",
        "Carbamato (propoxur).",
        "Carbaril + tetrametrina",
        "Carbarilo",
        "Carbon activado",
        "Carbon activado + sulfaguanidina",
        "Carbonato de calcio",
        "Carboplatino",
        "Carnitina + sorbitol + metionina + colina (cloruro) + vitamina b1(hcl) + b2 + b6 + b12 + acido nicotinico + pantotenato del calcio",
        "Carnitina + sorbitol + sulfato de magnesio",
        "Carnitina + taurina + complejo b",
        "Carprofeno",
        "Caseinato de calcio",
        "Cefadroxilo monohidrato",
        "Cefalexina",
        "Cefapiridi",
        "Cefapirina",
        "Cefoperazo",
        "Cefotaxima",
        "Ceftriaxon",
        "Cefuroxima",
        "Centella a",
        "Cetrimicid",
        "Ciclofosfa",
        "Ciclospori",
        "Cimetidina",
        "Cinarizina",
        "Ciprofloxa",
        "Ciprofloxa",
        "Ciprofloxa",
        "Ciprofloxa",
        "Ciprohepta",
        "Ciprohepta",
        "Cisaprida",
        "Cisplatino",
        "Citicolina + uridina + hidroxicobalamina",
        "Citrato",
        "Claritromicina",
        "Clenbuterol",
        "Clindamicina",
        "Clindamicina clorhidrato",
        "Clindamicina fosfato",
        "Clomipramina",
        "Clorambucilo",
        "Cloranfenicol",
        "Cloranfenicol + fucsina",
        "Cloranfenicol + violeta de genciana",
        "Cloranfenicol oftalmico",
        "Clorazepato",
        "Clordiazepoxido + bromuro de clidinio",
        "Clorfenamina (clorfeniramina)",
        "Clorhexidina",
        "Clorhexidina gluconato",
        "Clorhexidina gluconato + alcohol isopropilico",
        "Clorhexidina gluconato 2% + miconazol 2%",
        "Clorofila",
        "Clorpirifos",
        "Clorpirifos + tetrametrina",
        "Clorpirifos + tetrametrina + cipermetrina",
        "Clorpromazina",
        "Clorpropamida",
        "Cloruro de calcio",
        "Cloruro de obidoxima",
        "Cloruro de potasio",
        "Cloruro de sodio (suero fisiologico)",
        "Cloruro de trimetil amonio",
        "Clotrimazol",
        "Clotrimazol + &nbsp;dexametasona acetato",
        "Clotrimazol + betametasona dipropionato",
        "Clotrimazol + dexametasona",
        "Clotrimazol + gentamicina + betametasona",
        "Clotrimazol + zinc oxido",
        "Cloxacilina + ampicilina",
        "Codeina + seudoefedrina + clorfenamina",
        "Colonia para perros",
        "Complejo hierro-dextrano",
        "Compuesto yodado",
        "Condroitin sulfato + ciprofloxacino",
        "Condroitin sulfato + glucosamina",
        "Condroitin sulfato + glucosamina (oral)",
        "Condroitin sulfato a + cloruro de sodio",
        "Coumaphos (propoxur, carbaril)",
        "Crisantemato",
        "Cromoglicato disodico",
        "Cyfluthrin",
        "Danazol",
        "Decametrina (deltametrina) + piperonil butoxido",
        "Denatonium benzoato",
        "Desenredante de pelo",
        "Desmopresina",
        "Dexametasona",
        "Dexametasona + neomicina + bacitracina + griseofulvina + benzocaina",
        "Dexametasona 21 fosfato disodico usp",
        "Dexametasona fosfato",
        "Dexametasona sales, excepto fosfato",
        "Dexametasona trimetilacetato",
        "Diazepam",
        "Diazinon",
        "Diazinon (collar)",
        "Diazinon (dimpilato) + acidos grasos esenciales",
        "Diclofenaco sodico",
        "Diclorvos",
        "Diclorvos + triclosan",
        "Dietilamina salicilato + escina + heparinoide",
        "Difenadiona",
        "Difenhidramina",
        "Difethialona",
        "Digoxina",
        "Diltiazem",
        "Dioxido de cloro",
        "Dobutamina",
        "Domperidona",
        "Dopamina",
        "Doramectina",
        "Dorzalamida + timolol",
        "Dorzolamida + benzalconio + hidroxido de sodio",
        "Doxapram",
        "Doxiciclina",
        "Doxorrubicina",
        "Edta (edetato calcico disodico)",
        "Efedrina",
        "Embonato de pirantel + febantel",
        "Embutramida + yoduro de mebezonio + tetracaina",
        "Enalapril",
        "Enilconazol",
        "Enmascarador del mal aliento de menta",
        "Enrofloxacino",
        "Enrofloxacino + sulfadiazina de plata",
        "Ergonovina + dietilestilbestrol + piranisamida",
        "Eritromicina",
        "Eritropoyetina humana recombinante",
        "Esencias",
        "Espiramicina",
        "Estradiol benzoato",
        "Estradiol cipionato (ecp)",
        "Estreptomicina",
        "Etamsilato",
        "Etanol (alcohol alifatico)",
        "Etodolac",
        "Extracto de matico estandarizado",
        "Extracto hepatico + vitamina: b1 + b2 + b6 + b12 + niacinamida + cloruro de cobalto",
        "Extracto hepatico + vitamina: b1 + b2 + nicotinamida",
        "Famotidina",
        "Febantel + Pamoato de Pirantel + Prazicuantel + Ivermectina",
        "Febendazol + pamoato de pirantel",
        "Fenilbutazona",
        "Fenilbutazona + cincocaina",
        "Fenilbutazona + lidocaina + dimetil sulf",
        "Fenilefrina",
        "Fenitoina",
        "Fenobarbital",
        "Fenobarbital + bromuro de pipenzolato",
        "Fentanilo",
        "Feromona facial felina (fraccion f3), analogo sintetico",
        "Feromona facial felina (fraccion f4), analogo sintetico",
        "Fipronil",
        "Fipronil + metopreno (perros)",
        "Fipronil + metoprofeno (gatos)",
        "Firocoxib",
        "Fitomenadiona (vitamina k1)",
        "Fitomenadiona (vitamina k3) + sales biliares",
        "Flecainida acetato",
        "Fluconazol",
        "Flumequina",
        "Flumetasona",
        "Flumetrina",
        "Flumetrina + coumaphos",
        "Flunarizina",
        "Flunixina meglumina",
        "Fluoxetina",
        "Flutamida",
        "Formalina",
        "Fosfinato + oligoelementos (co, mo, se, zn, mg) + acido nicotinico",
        "Fsh",
        "Fsh + lf",
        "Ftalilsulfatiazol + sulfaguanidina + caolin + pectina",
        "Furazolidona",
        "Furazolidona + caolin",
        "Furosemida",
        "Furosemida + amilorida",
        "Gabapentina",
        "Gentamicina",
        "Gentamicina (oftalmico)",
        "Gentamicina + betametasona",
        "Gentamicina + betametasona otico",
        "Glibenclamida",
        "Glipizida",
        "Gluconato calcico",
        "Gluconato calcico + cloruro de magnesio",
        "Glucosa (dextrosa)",
        "Glucosa (dextrosa) hipertonica",
        "Glucosa + nacl",
        "Glucosa + nacl + lactato + cacl2 + mgcl",
        "Glucosamina + condroitin sulfato oral + manganeso",
        "Gonadotrofina corionica (pmsg)",
        "Gonadotrofina corionica humana (hcg)",
        "Griseofulvina",
        "Halotano",
        "Heparina",
        "Hidralazina",
        "Hidroclorotiazida",
        "Hidrocortisona",
        "Hidroxicina",
        "Hidroxietil almidón",
        "Hierro + ac. folico + vitamina c + vitamin",
        "Hierro sulfato",
        "Hierro sulfato + acido folico + retinol acetato + colecalciferol + calcio pantotenato + calcio + fosforo + magnesio + vitaminas: b12, b2, e, b",
        "Ibuprofeno",
        "Ictiol + extracto de belladona",
        "Idoxuridina + fenazona + nafazolina + nitrofurazona + benzalconio",
        "Imidacloprida",
        "Imidacloprida + cifenotrina",
        "Imidacloprida + permetrina",
        "Imipramina",
        "Insulina retardada nph (protamina neutra de hegedorn)",
        "Interferon alfa",
        "Isoflurano",
        "Isopropilo + eter nonilfenolico etoxilado",
        "Isosorbida",
        "Isotretinoina",
        "Itraconazol",
        "Ivermectina",
        "Jabon yodado",
        "Kanamicina sulfato acido + isopropamida yoduro + pectina + bismuto",
        "Ketamina",
        "Ketanserina",
        "Ketoconazol",
        "Ketoconazol (tópico)",
        "Ketoconazol + norfloxacina + lidocaina",
        "Ketoprofeno",
        "Ketorolaco",
        "L-lisina",
        "L-tianina + tiamina + l-triptofano + passiflora + valeriana + melissa",
        "Lactobacillus acidophillus + bifidobacterium bifidus + enterococcus faecium",
        "Lactulosa",
        "Leche liquida",
        "Levamisol",
        "Levotiroxina (t4)",
        "Lidocaina",
        "Lidocaina + violeta de genciana",
        "Lidocaina spray",
        "Limpia marca de lagrimas",
        "Lincomicina",
        "Lincomicina + espectinomicina",
        "Lindano",
        "Lipidos, emulsion esteril",
        "Lisinopril",
        "Loperamida",
        "Loratadina",
        "Lufenuron",
        "Magnesio hidroxido",
    ]

    let todayDate = moment().format("ddd, MMM D YYYY").toString()
    const [success, setSuccess] = useState(false)
    const [sucessMessage, setSucessMessage] = useState("")
    const [error, setError] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    
    const [fechaPeso, setFechaPeso] = useState(null)
    const [fechaFrecuenciaResp, setFechaFrecuenciaResp] = useState(null)
    const [fechaFrecuenciaCard, setFechaFrecuenciaCard] = useState(null)
    const [fechaPresionArterial, setFechaPresionArterial] = useState(null)

    const [fechaTemperatura, setFechaTemperatura] = useState(null)
    const [fechaCastrado, setFechaCastrado] = useState(null)
    const [fechaDesparacitacion, setFechaDesparacitacion] = useState(null)
    const [fechaVacunas, setFechaVacunas] = useState(null)
    const [fechaAlergias, setFechaAlergias] = useState(null)
    const [fechaPatologia, setFechaPatologia] = useState(null)
    const [fechaConsulta, setFechaConsulta] = useState(null)
    const [castracionFecha, setCastracionFecha] = useState(null)
    const [episodiosBool, setEpisodiosBool] = useState(false)
    const [examFisi, setExamFisi ] = useState(false)
    const [listoConsulta, setListoConsulta ] = useState(false)
    const [episodeShow, setEpisodeShow ] = useState(false)
    const [signosVitalesStatus, setSignosVitalesStatus ] = useState(false)
    const [palabra, setPalabra] = useState("")
    const [fechaNac, setFechaNac] = useState("")
    const [palabrasClave, setPalabrasClave] = useState([])
    const [ordenesEstudio, setOrdenesEstudio] = useState([])
    const [tratamientos, setTratamientos] = useState([])
    const [tiposPatologiasNew, setTiposPatologiasNew] = useState([])
    const [medicamentosNew, setMedicamentosNew] = useState([])
    const [ordenEstudio, setOrdenEstudio] = useState("")
    const [ordenComentario, setOrdenComentario] = useState("")
    const [antecedentes, setAntecedentes] = useState({})
    const [episodios, setEpisodios] = useState([])
    const [episode, setEpisode] = useState({})
    const [orden, setOrden] = useState({})
    
    const [tratamiento, setTratamiento] = useState({
        via: null,
        cant: null,
        unidad: null,
        frecuencia: null,
        durante: null,
        notaTratamiento: null
    })
    
    const [tratamientoExtras, setTratamientoExtras] = useState({
        frecuenciaNumber: null,
        frecuenciaText: null,
        duranteNumber: null,
        duranteText: null,
    })
    
    const [anteAmbientalValues, setAnteAmbientalValues] = useState({
        chip: "",
        lugarNacimiento: "",
        dondeVivido: "",
        tipoVivienda: "",
        convivenciaAnimales: "",
        actividadFisica: "",
    })
    
    const [anteFisiologicosValues, setAnteFisiologicosValues] = useState({
        tomaAgua: "",
        defecacion :"",
        diuresis: "",
        sueno: 0,
        fechaUltimoEstrogeno: "",
        frecuenciaCelos: "",
        castracion: false,
        castracionFecha: "",
        cirugiaEstetica: "",
        comentarioCirugia: "",
        gestante: "",
        cuantosPartos: "",
        tipoDuracionPartos: "",

    })
    
    const [anteFisicoValues, setAnteFisicoValues] = useState({
        inspeccionGeneral: "",
        mucosas: "",
        tiempoLlenadoCapilar: "",
        exploracionLinfonodulosSuperficiales: "",
        estadoHidratacion: "",
    })
    
    const [anteAparatosValues, setAnteAparatosValues] = useState({
        aparatoRespiratorio: "",
        aparatoCardiovascular: "",
        aparatoDigestivo: "",
        aparatoUrinario: "",
        aparatoReproductor: "",
        aparatoLocomotor: "",
        examenOjos: "",
        examenOidos: "",
        examenPiel: "",
        examenNeurologico: "",
    })
    const [anteAlimenticioValues, setAnteAlimenticioValues] = useState({
        tipoAlimenticio: "",
        marca: "",
        tipoAlimento: "",
        cacera: "",
        cantidad: "",
        frecuencia: "",
    })
    
    const [antePadresValues, setAntePadresValues] = useState({
        cancerMadre: false,
        diabetesMadre: false,
        cardiopatiasMadre: false,
        aparatoLocomotorMadre: false,
        sistemaNerviosoMadre: false,
        cancerPadre: false,
        diabetesPadre: false,
        cardiopatiasPadre: false,
        aparatoLocomotorPadre: false,
        sistemaNerviosoPadre: false,
        otras: "",
    })
    
    const [episodioValues, setEpisodioValues] = useState({
        detalleConsulta: "",
        diagnosticoConsulta: "",
        comentariosConsulta: "",
        instruccionesAdicionalesConsulta: "",
        ordenEspecialista: "",
    })
    
    const [valores, setValores] = useState({
        peso: "",
        temperatura: "",
        castrado: "",
        desparacitado: "",
        vacuna: "",
        alergia: "",
        patologia: "",
    })

    const [episodioStatus, setEpisodioStatus] = useState(false)
    const [eventoStatus, setEventoStatus] = useState(false)
    const [antecedentesStatus, setAntecedentesStatus] = useState(false)
    const [pet, setPet] = useState({})
    const [episodioSelected, setEpisodioSelected] = useState(null)
    const [alergias, setAlergias] = useState([])
    const [tiposAlergias, setTiposAlergias] = useState([])
    const [tiposVacunas, setTiposVacunas] = useState([])
    const [tiposPatologias, setTiposPatologias] = useState([])
    const [vacunas, setVacunas] = useState([])
    const [patologias, setPatologias] = useState([])
    const [desparacitaciones, setDesparacitaciones] = useState([])

    const getPet = async(mid) => {
        let alergias = []
        let vacunas = []
        let patologias = []
        let desparacitaciones = []
        try {
            firebase.db.collection("Mascotas").doc(mid).get().then((val)=>{
                setPet(val.data())
                setFechaNac(moment(val.data().fechanac.toDate()).format(`D MMMM, YYYY`).toString())
                let tiposVacunas = []
                let tiposAlergias = []
                let tiposPatologias = []
                firebase.db.collection("Especies").doc(val.data().especie).collection("Vacunas").get().then((val)=>{
                    Promise.all(val.docs.map(async (doc) => {
                        tiposVacunas.push(doc.id)
                    }))
                    setTiposVacunas(tiposVacunas)
                })
                firebase.db.collection("Especies").doc(val.data().especie).collection("Alergias").get().then((val)=>{
                    Promise.all(val.docs.map(async (doc) => {
                        tiposAlergias.push(doc.id)
                    }))
                    setTiposAlergias(tiposAlergias)
                })
                firebase.db.collection("Especies").doc(val.data().especie).collection("Patologias").get().then((val)=>{
                    Promise.all(val.docs.map(async (doc) => {
                        tiposPatologias.push(doc.id)
                    }))
                    setTiposPatologias(tiposPatologias)
                })
            })
            firebase.db.collection("Expedientes").doc(mid).collection("Alergias").get().then((val)=>{
                val.docs.forEach((doc)=>{
                    alergias.push(doc.data())
                })
                setAlergias(Array.from(new Set(alergias)))
            })
            firebase.db.collection("Expedientes").doc(mid).collection("Vacunas").get().then((val)=>{
                val.docs.forEach((doc)=>{
                    vacunas.push(doc.data())
                })
                setVacunas(Array.from(new Set(vacunas)))
            })
            firebase.db.collection("Expedientes").doc(mid).collection("Patologia").get().then((val)=>{
                val.docs.forEach((doc)=>{
                    patologias.push(doc.data())
                })
                setPatologias(Array.from(new Set(patologias)))
            })
            firebase.db.collection("Expedientes").doc(mid).collection("Desparasitacion").get().then((val)=>{
                val.docs.forEach((doc)=>{
                    desparacitaciones.push(doc.data())
                })
                // Array.from(new Set(tipos))
                setDesparacitaciones(Array.from(new Set(desparacitaciones)))
            })
            firebase.db.collection("Expedientes").doc(mid).collection("Episodios").onSnapshot((val) => {
                let tipos = []
                if (val.docs.length > 0) {
                    setEpisodiosBool(true)
                    Promise.all(val.docs.map(async (doc) => {
                        tipos.push(doc.data())
                    }))
                    setEpisodios(tipos.sort((a, b) => b.fechaConsulta - a.fechaConsulta))
                }
            });
            // firebase.db.collection("Expedientes").doc(mid).collection("Episodios").get().then((val)=>{
            //     let tipos = []
            //     if (val.docs.length > 0) {
            //         setEpisodiosBool(true)
            //         Promise.all(val.docs.map(async (doc) => {
            //             tipos.push(doc.data())
            //         }))
            //         setEpisodios(tipos)
            //     }
            // })
            firebase.db.collection("Expedientes").doc(mid).collection("Antecedentes").doc(mid).onSnapshot((val)=>{
                setAntecedentes(val.data())
                setAntePadresValues({...antePadresValues, 
                    cancerMadre: val.data() !== undefined && val.data().antePadresValues.cancerMadre,
                    diabetesMadre: val.data() !== undefined && val.data().antePadresValues.diabetesMadre,
                    cardiopatiasMadre: val.data() !== undefined && val.data().antePadresValues.cardiopatiasMadre,
                    aparatoLocomotorMadre: val.data() !== undefined && val.data().antePadresValues.aparatoLocomotorMadre,
                    sistemaNerviosoMadre: val.data() !== undefined && val.data().antePadresValues.sistemaNerviosoMadre,
                    cancerPadre: val.data() !== undefined && val.data().antePadresValues.cancerPadre,
                    diabetesPadre: val.data() !== undefined && val.data().antePadresValues.diabetesPadre,
                    cardiopatiasPadre: val.data() !== undefined && val.data().antePadresValues.cardiopatiasPadre,
                    aparatoLocomotorPadre: val.data() !== undefined && val.data().antePadresValues.aparatoLocomotorPadre,
                    sistemaNerviosoPadre: val.data() !== undefined && val.data().antePadresValues.sistemaNerviosoPadre
                })
                    
            })
        } catch (e) {
            console.log(`Error: ${e}`)
        }
    }

    function createOrden(){

        let orden = {}
        orden["ordenEstudio"] = ordenEstudio
        orden["ordenComentario"] = ordenComentario
        setOrdenesEstudio([...ordenesEstudio, orden])
        setOrdenComentario("")
        setOrdenEstudio("Seleccionar orden:")
    }
    
    function createTreatment(){

        var frecuencia = `${tratamientoExtras.frecuenciaNumber} ${tratamientoExtras.frecuenciaText}`
        var durante = `${tratamientoExtras.duranteNumber} ${tratamientoExtras.duranteText}`
        
        tratamiento.frecuencia = frecuencia
        tratamiento.durante = durante

        setTratamientos([...tratamientos, tratamiento])
        
        // tratamiento.nombre = ""
        setTratamiento({
            via: null,
            cant: null,
            unidad: null,
            frecuencia: null,
            durante: null,
            notaTratamiento: null
        })
        
        setTratamientoExtras({
            frecuenciaNumber: null,
            frecuenciaText: null,
            duranteNumber: null,
            duranteText: null,
        })

    }
  
    function createEtiquetaDiagnostico(palabra){
      let tipos = []
      if(palabra !== ""){
        for(let i = 0; i < tiposPatologias.length; i++){
          let w = tiposPatologias[i]
          if(w.toLowerCase().includes(palabra.toLowerCase())){
            tipos.push(w)
          }else{
            setTiposPatologiasNew([])
            setEpisodioValues({...episodioValues, diagnosticoConsulta: palabra})
          }
        }
        setTiposPatologiasNew(tipos)
      }else{
        setEpisodioValues({...episodioValues, diagnosticoConsulta: ""})
        setTiposPatologiasNew([])
      }
    }
    
    function createEtiquetaMedicamentos(palabra){
      let tipos = []
      if(palabra !== ""){
        for(let i = 0; i < medicamentos.length; i++){
          let w = medicamentos[i]
          if(w.toLowerCase().includes(palabra.toLowerCase())){
            tipos.push(w)
          }else{
            setMedicamentosNew([])
            setTratamiento({...tratamiento, nombre: palabra})
          }
        }
        setMedicamentosNew(tipos)
      }else{
        setTratamiento({...tratamiento, nombre: ""})
        setMedicamentosNew([])
      }
    }
  
    // const handleKeyPress = (event) => {
    //   if(event.key === 'Enter' && wordd !== ""){
    //     setWordss([...wordss, wordd])
    //   }
    // }

    const SuccessComponent = ({msg}) => {
        return (
            <div className="success-alert">
                <span className="material-icons mr-2">done</span>
                {msg}
                <div onClick={()=>{setSuccess(false)}} className="material-icons ml-2 cursor-pointer">close</div>
            </div>
        )
    }
    
    const ErrorComponent = ({msg}) => {
        return (
            <div className="error-alert">
                <span className="material-icons mr-2">error</span>
                {msg}
                <div onClick={()=>{setError(false)}} className="material-icons ml-2 cursor-pointer">close</div>
            </div>
        )
    }

    useEffect(() => {
        firebase.getCurrentUser().then((val)=>{
          setUser(val)
          getPet(data.state.mid)
        });
    }, [])

    return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
        <div className="main-content-container container-fluid px-4">
        {success && <SuccessComponent msg={sucessMessage === "" ? "Consulta guardada exitosamente" :  sucessMessage}/>}
        {error && <ErrorComponent msg={errorMessage === "" ? "Motivo de la consulta requerido " :  errorMessage}/>}
        { episodeShow && <div className="cc-modal-wrapper fadeIn">
              <div className="cc-modal cc-modal-scroll">
                <div className="cc-modal-header mb-2">
                  <div className="no-gutters mb-3 row align-items-center justify-content-spacebetween">
                    <h3 className="mb-0">Información de la consulta</h3>
                  </div>
                </div>
                <div className="cc-modal-body">
                    <div className="col-lg-12">
                        <div>
                            <p className="color-primary mb-1">{episode.motivoConsulta === "" ? "" : "Motivo de la consulta:"}</p>
                            <div className="row no-gutters">
                                {episode.motivoConsulta.map((mc)=>{
                                    return (
                                        <p className="pill-2">{mc}</p>
                                    )
                                })}
                            </div>
                        </div>
                        <div>
                            <p className="color-primary mb-1">{episode.comentariosConsulta === "" ? "" : "Comentarios de la consulta:"}</p>
                            <p>{episode.comentariosConsulta}</p>
                        </div>
                        <div>
                            <p className="color-primary mb-1">{episode.detalleConsulta === "" ? "" : "Detalle de la consulta:"}</p>
                            <p>{episode.detalleConsulta}</p>
                        </div>
                        <div>
                            <p className="color-primary mb-1">{episode.diagnosticoConsulta === "" ? "" : "Diagnostico de la consulta:"}</p>
                            <p>{episode.diagnosticoConsulta}</p>
                        </div>
                        <div>
                            <p className="color-primary mb-1">{episode.instruccionesAdicionalesConsulta === "" ? "" : "Instrucciones adicionales de la consulta:"}</p>
                            <p>{episode.instruccionesAdicionalesConsulta}</p>
                        </div>
                        { episode.ordenesEstudio !== undefined && <div>
                            <p className="color-primary mb-1">{episode.ordenesEstudio.length > 0 && "Órdenes de estudio:"}</p>
                            <div className="row no-gutters">
                                {episode.ordenesEstudio.map((mc, i)=>{
                                    return (
                                        <div className="pill-2 rounded" key={i}>
                                            <p className="mb-1 strong">{mc.ordenEstudio}</p>
                                            <p className="mb-0 light">{mc.ordenComentario} </p>
                                        </div>
                                        )
                                    })}
                            </div>
                        </div>
                        }
                        { episode.signosVitales !== undefined && <div>
                            <p className="color-primary mb-1">{ episode.signosVitales.peso !== "" 
                            && episode.signosVitales.temperatura !== "" 
                            && episode.signosVitales.frecuenciaResp !== "" 
                            && episode.signosVitales.frecuenciaCard !== "" 
                            && episode.signosVitales.presionArt !== "" 
                            ? "Signos vitales:" : ""}</p>
                            {episode.signosVitales.peso && <p className="mb-1" >Peso: {episode.signosVitales.peso} - { moment(episode.signosVitalesFechas[0].toDate()).format("ddd, D MMM YYYY").toString() } </p>}
                            {episode.signosVitales.temperatura && <p className="mb-1" >Temperatura: {episode.signosVitales.temperatura} - { moment(episode.signosVitalesFechas[1].toDate()).format("ddd, MMM D YYYY").toString() } </p>}
                            {episode.signosVitales.frecuenciaResp && <p className="mb-1" >Frecuencia respiratoria: {episode.signosVitales.frecuenciaResp} - { moment(episode.signosVitalesFechas[2].toDate()).format("ddd, D MMM YYYY").toString() } </p>}
                            {episode.signosVitales.frecuenciaCard && <p className="mb-1" >Frecuencia cardiaca: {episode.signosVitales.frecuenciaCard} - { moment(episode.signosVitalesFechas[3].toDate()).format("ddd, D MMM YYYY").toString() } </p>}
                            {episode.signosVitales.presionArt && <p className="mb-1" >Presion arterial: {episode.signosVitales.presionArt} - { moment(episode.signosVitalesFechas[4].toDate()).format("ddd, D MMM YYYY").toString() } </p>}
                        </div> } 
                        { episode.tratamientos !== undefined && <div>
                            <p className="color-primary mt-3 mb-1">{episode.tratamientos.length > 0 && "Tratamientos:"}</p>
                            <div className="row no-gutters">
                                {episode.tratamientos.map((tratamiento, i)=>{
                                    return (
                                        <div className="border-bottom" >                                        
                                            <p className="mb-0">{tratamiento.nombre}</p>
                                            <div className="row col-lg-12" key={i}>
                                                <p className="mb-0 mr-2">Cantidad: {tratamiento.cant}, </p>
                                                <p className="mb-0 mr-2">Durante: {tratamiento.durante}, </p>
                                                <p className="mb-0 mr-2">Frecuencia: {tratamiento.frecuencia}, </p>
                                                <p className="mb-0 mr-2">Unidad: {tratamiento.unidad}, </p>
                                                <p className="mb-0 mr-2">Via: {tratamiento.via}, </p>
                                            </div>
                                            <p className="mb-0">{tratamiento.notaTratamiento}</p>
                                        </div>
                                    )
                                })}
                            </div>
                        </div> }
                    </div>
                </div>
                <div className="cc-modal-footer align-items-center justify-content-spacebetween">
                  {/* <button onClick={()=>{setEpisodeShow(false)}} className={`btn btn-disabled`}>
                    Cancelar
                  </button> */}
                  <button onClick={()=>{setEpisodeShow(false)}} className={`btn btn-primary `}>
                    Volver
                  </button>
                </div>
              </div>
            </div>}
            { examFisi ? <div className="cc-modal-wrapper fadeIn">
              <div className="cc-modal cc-modal-scroll">
                <div className="cc-modal-header mb-2">
                  <div className="no-gutters mb-3 row align-items-center justify-content-spacebetween">
                    <h3 className="mb-0">Examen físico</h3>
                  </div>
                </div>
                <div className="cc-modal-body">
                    <div className="row">
                        <div className="col-lg-6">
                            <h4 className="my-3">Examen físico</h4>
                            <div className="row no-gutters align-items-center my-3">
                                <p className="mb-0 col-lg-6">Inspección general</p>
                                <input value={anteFisicoValues.inspeccionGeneral} onChange={(e)=>setAnteFisicoValues({...anteFisicoValues, inspeccionGeneral: e.target.value})} className="form-control col-lg-6"/>
                            </div>
                            <div className="row no-gutters align-items-center my-3">
                                <p className="mb-0 col-lg-6">Mucosas</p>
                                <input value={anteFisicoValues.mucosas} onChange={(e)=>setAnteFisicoValues({...anteFisicoValues, mucosas: e.target.value})} className="form-control col-lg-6"/>
                            </div>
                            <div className="row no-gutters align-items-center my-3">
                                <p className="mb-0 col-lg-6">Tiempo de llenado capilar</p>
                                <input value={anteFisicoValues.tiempoLlenadoCapilar} onChange={(e)=>setAnteFisicoValues({...anteFisicoValues, tiempoLlenadoCapilar: e.target.value})} className="form-control col-lg-6"/>
                            </div>
                            <div className="row no-gutters align-items-center my-3">
                                <p className="mb-0 col-lg-6">Exploración de ganglios linfáticos superficiales</p>
                                <input value={anteFisicoValues.exploracionLinfonodulosSuperficiales} onChange={(e)=>setAnteFisicoValues({...anteFisicoValues, exploracionLinfonodulosSuperficiales: e.target.value})} className="form-control col-lg-6"/>
                            </div>
                            <div className="row no-gutters align-items-center my-3">
                                <p className="mb-0 col-lg-6">Estado de hidratación</p>
                                <input value={anteFisicoValues.estadoHidratacion} onChange={(e)=>setAnteFisicoValues({...anteFisicoValues, estadoHidratacion: e.target.value})} className="form-control col-lg-6"/>
                            </div>

                            

                        </div>
                        <div className="col-lg-6">
                            <h4 className="my-3">Sistemas</h4>
                            <div className="row no-gutters align-items-center my-3">
                                <p className="col-lg-6 mb-0">Aparato respiratorio</p>
                                <input value={anteAparatosValues.aparatoRespiratorio} onChange={(e)=>setAnteAparatosValues({...anteAparatosValues, aparatoRespiratorio: e.target.value})} className="form-control col-lg-6"/>
                            </div>
                            <div className="row no-gutters align-items-center my-3">
                                <p className="col-lg-6 mb-0">Aparato cardiovascular</p>
                                <input value={anteAparatosValues.aparatoCardiovascular} onChange={(e)=>setAnteAparatosValues({...anteAparatosValues, aparatoCardiovascular: e.target.value})} className="form-control col-lg-6"/>
                            </div>
                            <div className="row no-gutters align-items-center my-3">
                                <p className="col-lg-6 mb-0">Aparato digestivo</p>
                                <input value={anteAparatosValues.aparatoDigestivo} onChange={(e)=>setAnteAparatosValues({...anteAparatosValues, aparatoDigestivo: e.target.value})} className="form-control col-lg-6"/>
                            </div>
                            <div className="row no-gutters align-items-center my-3">
                                <p className="col-lg-6 mb-0">Aparato urinario</p>
                                <input value={anteAparatosValues.aparatoUrinario} onChange={(e)=>setAnteAparatosValues({...anteAparatosValues, aparatoUrinario: e.target.value})} className="form-control col-lg-6"/>
                            </div>
                            <div className="row no-gutters align-items-center my-3">
                                <p className="col-lg-6 mb-0">Aparato reproductor</p>
                                <input value={anteAparatosValues.aparatoReproductor} onChange={(e)=>setAnteAparatosValues({...anteAparatosValues, aparatoReproductor: e.target.value})} className="form-control col-lg-6"/>
                            </div>
                            <div className="row no-gutters align-items-center my-3">
                                <p className="col-lg-6 mb-0">Aparato locomotor</p>
                                <input value={anteAparatosValues.aparatoLocomotor} onChange={(e)=>setAnteAparatosValues({...anteAparatosValues, aparatoLocomotor: e.target.value})} className="form-control col-lg-6"/>
                            </div>
                            <div className="row no-gutters align-items-center my-3">
                                <p className="col-lg-6 mb-0">Inspección oftálmica</p>
                                <input value={anteAparatosValues.examenOjos} onChange={(e)=>setAnteAparatosValues({...anteAparatosValues, examenOjos: e.target.value})} className="form-control col-lg-6"/>
                            </div>
                            <div className="row no-gutters align-items-center my-3">
                                <p className="col-lg-6 mb-0">Inspección oidos</p>
                                <input value={anteAparatosValues.examenOidos} onChange={(e)=>setAnteAparatosValues({...anteAparatosValues, examenOidos: e.target.value})} className="form-control col-lg-6"/>
                            </div>
                            <div className="row no-gutters align-items-center my-3">
                                <p className="col-lg-6 mb-0">Inspección piel</p>
                                <input value={anteAparatosValues.examenPiel} onChange={(e)=>setAnteAparatosValues({...anteAparatosValues, examenPiel: e.target.value})} className="form-control col-lg-6"/>
                            </div>
                            <div className="row no-gutters align-items-center my-3">
                                <p className="col-lg-6 mb-0">Inspección neurológica</p>
                                <input value={anteAparatosValues.examenNeurologico} onChange={(e)=>setAnteAparatosValues({...anteAparatosValues, examenNeurologico: e.target.value})} className="form-control col-lg-6"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="cc-modal-footer align-items-center justify-content-spacebetween">
                  <button onClick={()=>{setExamFisi(false)}} className={`btn btn-disabled`}>
                    Cancelar
                  </button>
                  <button onClick={()=>{setExamFisi(false);}} className={`btn btn-primary`}>
                    Guardar
                  </button>
                </div>
              </div>
            </div> : <div></div> }
            { signosVitalesStatus && <div className="cc-modal-wrapper fadeIn">
              <div className="cc-modal">
                <div className="cc-modal-header mb-2">
                  <div className="no-gutters mb-3 row align-items-center justify-content-spacebetween">
                    <h3 className="mb-0">Signos vitales</h3>
                  </div>
                </div>
                <div className="cc-modal-body">
                    <div className="col-lg-12 px-5">
                        <div className="row mb-4 align-items-center justify-content-spacebetween">
                            <input onChange={(e)=>{setValores({...valores, peso: e.target.value})}} type="text" className="form-control  col-lg-4" placeholder="Peso (Kg)"/>
                            <div className="col-lg-5 spe-input">
                            <DatePicker
                                className="col-lg-12"
                                format="ddd, MMM D YYYY"
                                placeholder={todayDate}
                                maxDate={moment().toDate()}
                                label=""
                                okLabel="Listo"
                                cancelLabel="Cancelar"
                                value={fechaPeso}
                                onChange={setFechaPeso}
                                animateYearScrolling
                            />
                            </div>
                        </div>
                        <div className="row mb-4 align-items-center justify-content-spacebetween">
                            <input onChange={(e)=>{setValores({...valores, temperatura: e.target.value})}} type="text" className="form-control  col-lg-4" placeholder="Temperatura (ºC)"/>
                            <div className="col-lg-5 spe-input">
                            <DatePicker
                                className="col-lg-12"
                                format="ddd, MMM D YYYY"
                                placeholder={todayDate}
                                maxDate={moment().toDate()}
                                label=""
                                okLabel="Listo"
                                cancelLabel="Cancelar"
                                value={fechaTemperatura}
                                onChange={setFechaTemperatura}
                                animateYearScrolling
                            />
                            </div>
                        </div>
                        <div className="row mb-4 align-items-center justify-content-spacebetween">
                            <input value={valores.frecuenciaResp} onChange={(e)=>{setValores({...valores, frecuenciaResp: e.target.value})}} type="text" className="form-control  col-lg-4" placeholder="Frecuencia respiratoria"/>
                            <div className="col-lg-5 spe-input">
                            <DatePicker
                                className="col-lg-12"
                                format="ddd, MMM D YYYY"
                                placeholder={todayDate}
                                maxDate={moment().toDate()}
                                label=""
                                okLabel="Listo"
                                cancelLabel="Cancelar"
                                value={fechaFrecuenciaResp}
                                onChange={setFechaFrecuenciaResp}
                                animateYearScrolling
                            />
                            </div>
                        </div>
                        <div className="row mb-4 align-items-center justify-content-spacebetween">
                            <input value={valores.frecuenciaCard} onChange={(e)=>{setValores({...valores, frecuenciaCard: e.target.value})}} type="text" className="form-control  col-lg-4" placeholder="Frecuencia cardiaca"/>
                            <div className="col-lg-5 spe-input">
                            <DatePicker
                                className="col-lg-12"
                                format="ddd, MMM D YYYY"
                                placeholder={todayDate}
                                maxDate={moment().toDate()}
                                label=""
                                okLabel="Listo"
                                cancelLabel="Cancelar"
                                value={fechaFrecuenciaCard}
                                onChange={setFechaFrecuenciaCard}
                                animateYearScrolling
                            />
                            </div>
                        </div>
                        <div className="row mb-4 align-items-center justify-content-spacebetween">
                            <input value={valores.presionArt} onChange={(e)=>{setValores({...valores, presionArt: e.target.value})}} type="text" className="form-control  col-lg-4" placeholder="Presión arterial"/>
                            <div className="col-lg-5 spe-input">
                            <DatePicker
                                className="col-lg-12"
                                format="ddd, MMM D YYYY"
                                placeholder={todayDate}
                                maxDate={moment().toDate()}
                                label=""
                                okLabel="Listo"
                                cancelLabel="Cancelar"
                                value={fechaPresionArterial}
                                onChange={setFechaPresionArterial}
                                animateYearScrolling
                            />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="cc-modal-footer align-items-center justify-content-spacebetween">
                  <button onClick={()=>{setSignosVitalesStatus(false)}} className={`btn btn-disabled`}>
                    Cancelar
                  </button>
                  <button onClick={()=>{setSignosVitalesStatus(false)}} className={`btn btn-primary`}>
                    Guardar
                  </button>
                </div>
              </div>
            </div>}
            { listoConsulta && <div className="cc-modal-wrapper fadeIn">
                <div className="c2-modal">
                    <div className="cc-modal-header mb-2">
                        <h3 className="mb-0">Evento creado exitosamente</h3>
                    </div>
                    <div className="c2-modal-body">
                       <p className="mb-0">
                           ¿Desea cerrar la atención y volver a la agenda?
                       </p>
                    </div>
                    <div className="cc-modal-footer align-items-center justify-content-spacebetween">
                      <button onClick={()=>{setListoConsulta(false)}} className="btn btn-outline-secondary">
                        No
                      </button>
                      <button onClick={()=>{
                          history.push({
                            // state: {roleId: data.state.roleId},
                            pathname: "/agenda"
                        })
                      }} className={`btn btn-primary`}>
                        Sí
                      </button>
                    </div>
                </div>
            </div>}
            <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
                <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
                    <div className="row align-items-center">
                        <div className="ml-2 col row">
                          <p className="page-title bold"><Link className="page-title light" to="/clients">Clientes</Link> 
                          <span onClick={()=>{ history.push({ pathname: "/clients/client", state: {uid: data.state.uid}})}} className="ml-3 page-title light clientHistory cursor-pointer">Cliente</span> 
                          <span>Historia de la mascota</span ></p>
                        </div>
                        {/* <div className="col">
                            <p className="page-title bold">
                                <Link to="/clients" className="page-title light">Clientes</Link>{' > '}
                                <span onClick={()=>{
                                    history.push({
                                      pathname: "/clients/client",
                                      state: {uid: data.state.uid}
                                    })
                                }} className="page-title light">Cliente</span>{' > '}Historia de la mascota</p>
                        </div> */}
                    </div>
                </div>
                <div className="col-12 col-sm-1 mb-0">
                    <div className="row align-items-center justify-content-space-around">
                        <i className="material-icons color-white display-5">help_outline</i>
                    </div>
                </div>
            </div>
            
            <div className="container">
                {/* Informacion mascota */}
                <div className="row box-info-wrapper align-items-center justify-content-spacebetween">
                    <div className="col-lg-4">
                        <div className="box-info text-center">
                            <img src={pet.petthumbnailUrl} className="box-info-img"/>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="box-info">
                            <p className="mb-0 box-info-p strong">{pet.nombre}</p>
                        </div>
                        <div className="box-info">
                            <p className="mb-0 box-info-p">Especie: {pet.especie}</p>
                        </div>
                        <div className="box-info">
                            <p className="mb-0 box-info-p">{pet.sexo === "Hembra" ? "Esterilización:" : "Castrado:" } { antecedentes !== undefined && antecedentes.anteFisiologicosValues !== undefined ? ( antecedentes.anteFisiologicosValues.castracion ? "Sí - " + antecedentes.anteFisiologicosValues.castracionFecha : "No" ) : ""}</p>
                        </div>
                        <div className="box-info">
                            <p className="mb-0 box-info-p">Fecha de nacimiento: {fechaNac}</p>
                            {/* <p className="mb-0 box-info-p">Fecha de nacimiento:{ pet.fechanac ? pet.fechanac.toDate() : "26 de Mayo, 2016"}</p> */}
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="box-info">
                            <p className="mb-0 box-info-p">Raza: {pet.raza}</p>
                        </div>
                        <div className="box-info">
                            <p className="mb-0 box-info-p">Edad: 3 años y 5 meses</p>
                        </div>
                    </div>
                </div>
                {/* End informacion mascota */}
                <div className="row mt-4">
                    {/* General */}
                    <div className={ antecedentesStatus ? "col-lg-12 mb-5" : "col-lg-8 mb-5"}>
                        <div className="row">
                            <div className="col-lg-3">
                                <p onClick={()=>{setEpisodioStatus(true); setEventoStatus(false); setAntecedentesStatus(false)}} className={`btn btn-no-padding-x btn-block ${episodioStatus ? "btn-primary" : "btn-outline-primary"}`}>
                                    Nuevo evento
                                </p>
                            </div>
                            <div className="col-lg-3">
                                <p onClick={()=>{setEpisodioStatus(false); setEventoStatus(false); setAntecedentesStatus(false)}} className={`btn btn-no-padding-x btn-block ${!eventoStatus && !episodioStatus & !antecedentesStatus ? "btn-primary" : "btn-outline-primary"}`}>
                                    Control
                                </p>
                            </div>
                            { antecedentes === undefined && <div className="col-lg-3">
                                <p onClick={()=>{setEpisodioStatus(false); setEventoStatus(false); setAntecedentesStatus(true)}} className={`btn btn-no-padding-x btn-block ${antecedentesStatus ? "btn-primary" : "btn-outline-primary"}`}>
                                    Antecedentes
                                </p>
                            </div>}
                        </div>
                        { !episodioStatus && !eventoStatus & !antecedentesStatus ?
                            <Tabs>
                                <TabList>
                                    <Tab>Patologías</Tab>
                                    <Tab>Vacunas</Tab>
                                    <Tab>Desparasitaciones</Tab>
                                    <Tab>Alergias</Tab>

                                </TabList>
                                <TabPanel>
                                    {patologias.map((val)=>{
                                        let oc = moment(val.fechaPatologia.toDate()).format("ddd, MMM D YYYY")
                                        return (
                                            <div key={val.eid} className="mb-2 row align-items-center justify-content-spacebetween border-bottom">
                                                <div className="mb-1 col-lg-6">{val.patologia}</div>
                                                <div className="mb-1 col-lg-6">{oc}</div>
                                            </div>
                                        )
                                    })}
                                    <div className="row align-items-center justify-content-spacebetween">
                                        <select value={valores.patologia} placeholder="Patología" onChange={(e)=>setValores({...valores, patologia: e.target.value})} className="mt-3 form-control col-lg-4">
                                            <option>Selecciona una patología:</option>
                                            {tiposPatologias.map((a)=>{
                                                return (
                                                    <option key={a} value={a}>{a}</option>
                                                )
                                            })}
                                        </select>
                                        <div className="mt-3 col-lg-5 spe-input">
                                          <DatePicker
                                            className="col-lg-12"
                                            format="ddd, MMM D YYYY"
                                            placeholder={todayDate}
                                            maxDate={moment().toDate()}
                                            label=""
                                            okLabel="Listo"
                                            cancelLabel="Cancelar"
                                            value={fechaPatologia}
                                            onChange={setFechaPatologia}
                                            animateYearScrolling
                                          />
                                        </div>
                                        <div onClick={()=>{valores.patologia === "" ? console.log("Error") : saveGeneral("g")}}  className="mt-3 btn btn-outline-secondary col-lg-3">Nueva patología</div>
                                    </div>
                                </TabPanel>
                                <TabPanel>
                                    {vacunas.map((val)=>{
                                        let oc = moment(val.fechaVacuna.toDate()).format("ddd, MMM D YYYY")
                                        return (
                                            <div key={val.eid} className="mb-2 row align-items-center justify-content-spacebetween border-bottom">
                                                <div className="mb-1 col-lg-6">{val.vacuna}</div>
                                                <div className="mb-1 col-lg-6">{oc}</div>
                                            </div>  
                                        )
                                    })}
                                    <div className="row align-items-center justify-content-spacebetween">
                                        <select value={valores.vacuna} placeholder="Vacuna" onChange={(e)=>setValores({...valores, vacuna: e.target.value})} className="mt-3 form-control col-lg-4">
                                            <option>Selecciona una vacuna:</option>
                                            {tiposVacunas.map((a)=>{
                                                return (
                                                    <option key={a} value={a}>{a}</option>
                                                )
                                            })}
                                        </select>
                                        <div className="mt-3 col-lg-5 spe-input">
                                          <DatePicker
                                            className="col-lg-12"
                                            format="ddd, MMM D YYYY"
                                            placeholder={todayDate}
                                            maxDate={moment().toDate()}
                                            label=""
                                            okLabel="Listo"
                                            cancelLabel="Cancelar"
                                            value={fechaVacunas}
                                            onChange={setFechaVacunas}
                                            animateYearScrolling
                                          />
                                        </div>
                                        <div  onClick={()=>{valores.vacuna === "" ? console.log("Error") : saveGeneral("e")}} className="mt-3 btn btn-outline-secondary col-lg-3">Nueva vacuna</div>
                                    </div>
                                </TabPanel>
                                <TabPanel>
                                    {desparacitaciones.map((val)=>{
                                        let oc = moment(val.fechaDesparasitacion.toDate()).format("ddd, MMM D YYYY")
                                        return (
                                            <div key={val.eid} className="mb-2 row align-items-center justify-content-spacebetween border-bottom">
                                                <div className="mb-1 col-lg-6">{oc}</div>
                                            </div>  
                                        )
                                    })}
                                    <div className="row align-items-center justify-content-spacebetween">
                                        <div className="mt-3 col-lg-5 spe-input">
                                          <DatePicker
                                            className="col-lg-12"
                                            format="ddd, MMM D YYYY"
                                            placeholder={todayDate}
                                            maxDate={moment().toDate()}
                                            label=""
                                            okLabel="Listo"
                                            cancelLabel="Cancelar"
                                            value={fechaDesparacitacion}
                                            onChange={setFechaDesparacitacion}
                                            animateYearScrolling
                                          />
                                        </div>
                                        <div onClick={()=>{fechaDesparacitacion !== null ? console.log("Error") : saveGeneral("d")}} className="mt-3 btn btn-outline-secondary col-lg-3">Nueva despacitación</div>
                                    </div>
                                </TabPanel>
                                <TabPanel>
                                    {alergias.map((val)=>{
                                        let oc = moment(val.fechaAlergia.toDate()).format("ddd, MMM D YYYY")
                                        return (
                                            <div key={val.eid} className="mb-2 row align-items-center justify-content-spacebetween border-bottom">
                                                <div className="mb-1 col-lg-6">{val.alergia}</div>
                                                <div className="mb-1 col-lg-6">{oc}</div>
                                            </div>  
                                        )
                                    })}
                                    <div className="row align-items-center justify-content-spacebetween">
                                        <select value={valores.alergia} placeholder="Alergia" onChange={(e)=>setValores({...valores, alergia: e.target.value})} className="mt-3 form-control col-lg-4">
                                            <option>Selecciona un tipo de alergia:</option>
                                            {tiposAlergias.map((a)=>{
                                                return (
                                                    <option key={a} value={a}>{a}</option>
                                                )
                                            })}
                                        </select>
                                        <div className="mt-3 col-lg-5 spe-input">
                                          <DatePicker
                                            className="col-lg-12"
                                            format="ddd, MMM D YYYY"
                                            placeholder={todayDate}
                                            maxDate={moment().toDate()}
                                            label=""
                                            okLabel="Listo"
                                            cancelLabel="Cancelar"
                                            value={fechaAlergias}
                                            onChange={setFechaAlergias}
                                            animateYearScrolling
                                          />
                                        </div>
                                        <div onClick={()=>{valores.alergia === "" ? console.log("Error") : saveGeneral("f")}} className="mt-3 btn btn-outline-secondary col-lg-3">Nueva alergia</div>
                                    </div>
                                </TabPanel>
                            </Tabs>
                        : episodioStatus ? 
                            <div>
                                <div className="row align-items-center justify-content-spacebetween">
                                    <p className="col-lg-7 mb-0">Fecha de consulta</p>
                                    <div className="mt-3 col-lg-5 spe-input">
                                      <DatePicker
                                        className="col-lg-12"
                                        format="ddd, MMM D YYYY"
                                        placeholder={todayDate}
                                        maxDate={moment().toDate()}
                                        label=""
                                        okLabel="Listo"
                                        cancelLabel="Cancelar"
                                        value={fechaConsulta}
                                        onChange={setFechaConsulta}
                                        animateYearScrolling
                                      />
                                    </div>
                                </div>
                                <div className="row align-items-center justify-content-spacebetween">
                                    <p className="col-lg-4 mb-0">Motivo de la consulta</p>
                                    <div className="form-group col-lg-4 mt-3">
                                      <input type="text" value={palabra} onChange={e=>{setPalabra(e.target.value)}} placeholder="Dolor de cabeza" className="form-control"/>
                                    </div>
                                    <div className="form-group col-lg-4 mt-3">
                                        <span onClick={()=>{ palabra === "" ? console.log("Error") : setPalabrasClave([...palabrasClave, palabra]); setPalabra("") }} className={palabra === "" ? "btn btn-disabled btn-block" : "btn btn-primary btn-block"}>Añadir</span>
                                    </div>
                                </div>
                                <div className="px-3 row">
                                  {palabrasClave.map(p => (
                                    <p className="pill" key={p}>{p} <span className="cursor-pointer btn-delete" onClick={()=>{ setPalabrasClave(palabrasClave.filter((p1) => p1 !== p)); }} >X</span></p>
                                  ))}
                                </div>
                                <div className="row align-items-center justify-content-spacebetween">
                                    <p className="col-lg-4 mb-0">Detalle</p>
                                    <textarea placeholder="Detalle de la consulta" value={episodioValues.detalleConsulta}
                                        onChange={(e) => setEpisodioValues({...episodioValues, detalleConsulta: e.target.value})} className="mt-3 form-control col-lg-8"/>
                                </div>
                                <div className="row align-items-center justify-content-spacebetween">
                                    <p className="col-lg-7 mb-0">Examen físico</p>
                                    <div onClick={()=>{setExamFisi(true)}} className="mt-3 btn btn-secondary col-lg-3">Ver</div>
                                </div>
                                <div className="row align-items-center justify-content-spacebetween">
                                    <p className="col-lg-7 mb-0">Signos vitales</p>
                                    <div onClick={()=>{setSignosVitalesStatus(true)}} className="mt-3 btn btn-secondary col-lg-3">Ver</div>
                                </div>
                                <div className="row align-items-center justify-content-spacebetween">
                                    <p className="col-lg-7 mb-0">Diagnostico</p>
                                    <div className="mt-3 col-lg-4 custom-dropdown">
                                      <input placeholder={tiposPatologias[0]} value={episodioValues.diagnosticoConsulta} onChange={(e)=>{ createEtiquetaDiagnostico(e.target.value) }} className="form-control"/>
                                      <div className="custom-dropdown-box">
                                        {tiposPatologiasNew.map((val, i)=>{
                                            return (
                                            <div className="custom-dropdown-option cursor-pointer" onClick={()=>{ setEpisodioValues({...episodioValues, diagnosticoConsulta: val});  setTiposPatologiasNew([]) } } key={i}>
                                                {val}
                                            </div>
                                            )
                                        })}
                                      </div>
                                    </div>
                                </div>
                                <div className="row align-items-center justify-content-spacebetween">
                                    <p className="col-lg-4 mb-0">Comentarios</p>
                                    <textarea placeholder="Comentarios adicionales de la consulta" value={episodioValues.comentariosConsulta} onChange={(e) => setEpisodioValues({...episodioValues, comentariosConsulta: e.target.value})} className="mt-3 form-control col-lg-8"/>
                                </div>
                                <div className="row align-items-center justify-content-spacebetween">
                                    <p className="col-lg-4 mb-0">Órdenes para estudios</p>
                                    <select id="ordenEstudioInput" onChange={(e)=>{setOrdenEstudio(e.target.value)}} value={ordenEstudio} className="mt-3 form-control col-lg-4">
                                        {ordenesList.map((v, i) =>{
                                            return (
                                                <option key={i} value={v}>{v}</option>
                                            )
                                        })}
                                    </select>

                                    {/* <div className="mt-3 col-lg-4 custom-dropdown">
                                      <input placeholder={tiposPatologias[0]} value={episodioValues.diagnosticoConsulta} onChange={(e)=>{ createEtiquetaDiagnostico(e.target.value) }} className="form-control"/>
                                      <div className="custom-dropdown-box">
                                        {tiposPatologiasNew.map((val, i)=>{
                                            return (
                                            <div className="custom-dropdown-option cursor-pointer" onClick={()=>{ setEpisodioValues({...episodioValues, diagnosticoConsulta: val});  setTiposPatologiasNew([]) } } key={i}>
                                                {val}
                                            </div>
                                            )
                                        })}
                                      </div>
                                    </div> */}

                                    <div className="form-group col-lg-4 mt-3">
                                        <span onClick={()=>{ (ordenEstudio !== "" && ordenEstudio !== "Seleccionar orden:") ? createOrden() : console.log("Error")}} className={(ordenEstudio !== "" && ordenEstudio !== "Seleccionar orden:")? "btn btn-primary btn-block" : "btn btn-disabled btn-block" }>Añadir</span>
                                    </div>
                                </div>
                                {ordenEstudio !== "" && ordenEstudio !== "Seleccionar orden:" ?
                                    <textarea id="ordenComentarioInput" placeholder="Nota de la órden" value={ordenComentario} onChange={(e)=>{ setOrdenComentario(e.target.value) }} className="mt-3 form-control col-lg-8"/>
                                : <div></div>
                                }
                                <div className="px-3 mt-3 row">
                                  {ordenesEstudio.map((p, i) => (
                                      <div className="pill" key={i}>
                                        <p className="mb-1 strong">{p.ordenEstudio} <span className="cursor-pointer btn-delete" onClick={()=>{ setOrdenesEstudio(ordenesEstudio.filter((p1) => p1 !== p)); }} >X</span></p>
                                        {p.ordenComentario !== "" && <p className="mb-0 light">{p.ordenComentario} </p>}
                                      </div>
                                  ))}
                                </div>
                                <div className="row align-items-center justify-content-spacebetween">
                                    <p className="col-lg-4 mb-0">Tratamiento</p>
                                    {/* <select onChange={(e)=>{setTratamiento({...tratamiento, nombre: e.target.value})}} value={tratamiento.nombre} className="mt-3 form-control col-lg-4"  placeholder="W">
                                        {medicamentos.map((v, i) =>{
                                            return (
                                                <option key={i} value={v}>{v}</option>
                                            )
                                        })}
                                    </select> */}

                                    <div className="mt-3 col-lg-4 custom-dropdown">
                                      <input placeholder={medicamentos[0]} value={tratamiento.nombre} onChange={(e)=>{ createEtiquetaMedicamentos(e.target.value) }} className="form-control"/>
                                      <div className="custom-dropdown-box">
                                        {medicamentosNew.map((val, i)=>{
                                            return (
                                            <div className="custom-dropdown-option cursor-pointer" onClick={()=>{ setTratamiento({...tratamiento, nombre: val});  setMedicamentosNew([]) } } key={i}>
                                                {val}
                                            </div>
                                            )
                                        })}
                                      </div>
                                    </div>
                                    <span onClick={()=>{ 
                                        if(tratamiento.via && tratamiento.cant && tratamiento.unidad && tratamientoExtras.duranteText && tratamientoExtras.duranteNumber){
                                            createTreatment();
                                            setTratamiento({...tratamiento, nombre: ""});
                                            // setTratamiento({...tratamiento, via: null});
                                            // setTratamiento({...tratamiento, cant: null});
                                            // setTratamiento({...tratamiento, unidad: null});
                                            // setTratamiento({...tratamiento, frecuencia: null});
                                            // setTratamiento({...tratamiento, notaTratamiento: null});
                                            // setTratamientoExtras({...tratamientoExtras, frecuenciaNumber: null});
                                            // setTratamientoExtras({...tratamientoExtras, frecuenciaText: null});
                                            // setTratamientoExtras({...tratamientoExtras, duranteNumber: null});
                                            // setTratamientoExtras({...tratamientoExtras, duranteText: null});
                                        }else{
                                            console.log("Error")
                                        }
                                        }} 
                                    className={tratamiento.via && tratamiento.cant && tratamiento.unidad && tratamientoExtras.frecuenciaNumber && tratamientoExtras.duranteNumber ? "btn btn-primary btn-block col-lg-4 " : "btn btn-disabled btn-block col-lg-4 "}>Añadir</span>
                                        
                                </div>
                                <div className="px-3 pt-3 row">
                                  {tratamientos.map((p, i) => (
                                    <p className="pill" key={i}>
                                        <p className="mb-1 strong">{p.nombre} <span className="cursor-pointer btn-delete" onClick={()=>{ setTratamientos(tratamientos.filter((p1) => p1 !== p)); }} >X</span></p>
                                        <p className="mb-0 light">{p.notaTratamiento}</p>
                                    </p>
                                  ))}
                                </div>
                                {tratamiento.nombre ? 
                                
                                <>
                                    <div className="">
                                        <div className="row no-gutters">
                                            <div className="col-lg-6">
                                                <div className="treatment-header">Dosis</div>
                                                <div className="treatment-body row">
                                                    <div className="col-lg-4">
                                                        <div className="mb-2">Via</div>
                                                        <select onChange={(e)=>{setTratamiento({...tratamiento, via: e.target.value})}} value={tratamiento.via} className="form-control">
                                                            <option value=""></option>
                                                            <option value="Anal">Anal</option>
                                                            <option value="Auditiva">Auditiva</option>
                                                            <option value="Nasal">Nasal</option>
                                                            <option value="Oral">Oral</option>
                                                            <option value="Ocular">Ocular</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="mb-2">Cantidad</div>
                                                        <input onChange={(e)=>{setTratamiento({...tratamiento, cant: e.target.value})}} value={tratamiento.cant} className="form-control"/>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="mb-2">Unidad</div>
                                                        <select onChange={(e)=>{setTratamiento({...tratamiento, unidad: e.target.value})}} value={tratamiento.unidad} className="form-control">
                                                            <option value=""></option>
                                                            <option value="Capsulas">Cápsulas</option>
                                                            <option value="Gotas">Gotas</option>
                                                            <option value="Ampollas">Ampollas</option>
                                                            <option value="Uncion">Unción</option>
                                                            <option value="Tableta">Tableta</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="treatment-header">Duración</div>
                                                <div className="treatment-body row">
                                                    <div className="col-lg-6">
                                                        <div className="mb-2">Frecuencia</div>
                                                        <div className="row no-gutters">
                                                            <input onChange={(e)=>{setTratamientoExtras({...tratamientoExtras, frecuenciaNumber: e.target.value})}} value={tratamientoExtras.nombre} className="form-control col-lg-6"/>
                                                            <select onChange={(e)=>{setTratamientoExtras({...tratamientoExtras, frecuenciaText: e.target.value})}} value={tratamientoExtras.nombre} className="form-control col-lg-6">
                                                                <option value=""></option>
                                                                <option value="Minutos">Minutos</option>
                                                                <option value="Horas">Horas</option>
                                                                <option value="Dias">Dias</option>
                                                                <option value="Interdiaria">Interdiaria</option>
                                                                <option value="Semanas">Semanas</option>
                                                                <option value="Meses">Meses</option>
                                                                <option value="Años">Años</option>
                                                                <option value="Dia">Dia</option>
                                                                <option value="Diaria">Diaria</option>
                                                                <option value="Mañanas">Mañanas</option>
                                                                <option value="Noches">Noches</option>
                                                                <option value="Mañana y noche">Mañana y noche</option>
                                                                <option value="Después de cada comida">Después de cada comida</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="mb-2">Durante</div>
                                                        <div className="row no-gutters">
                                                            <input onChange={(e)=>{setTratamientoExtras({...tratamientoExtras, duranteNumber: e.target.value})}} value={tratamientoExtras.nombre} className="form-control col-lg-6"/>
                                                            <select onChange={(e)=>{setTratamientoExtras({...tratamientoExtras, duranteText: e.target.value})}} value={tratamientoExtras.nombre} className="form-control col-lg-6">
                                                                <option value=""></option>
                                                                <option value="Horas">Horas</option>
                                                                <option value="Dias">Días</option>
                                                                <option value="Semanas">Semanas</option>
                                                                <option value="Meses">Meses</option>
                                                                <option value="Años">Años</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <textarea onChange={(e)=>{setTratamiento({...tratamiento, notaTratamiento: e.target.value})}} value={tratamiento.notaTratamiento} placeholder="Nota del tratamiento" className="my-2 form-control col-lg-12"/>
                                </>

                                : <div></div>}
                                <div className="row align-items-center justify-content-spacebetween">
                                    <p className="col-lg-4 mb-0">Instrucciones adicionales</p>
                                    <textarea placeholder="Instrucciones adicionales de la consulta" value={episodioValues.instruccionesAdicionalesConsulta} onChange={(e) => setEpisodioValues({...episodioValues, instruccionesAdicionalesConsulta: e.target.value})} className="mt-3 form-control col-lg-8"/>
                                </div>
                                <div className="row align-items-center justify-content-spacebetween">
                                    <p className="col-lg-4 mb-0">Órden especialista</p>
                                    <input placeholder="Nombre de la especialidad" value={episodioValues.ordenEspecialista} onChange={(e) => setEpisodioValues({...episodioValues, ordenEspecialista: e.target.value})} className="mt-3 form-control col-lg-8"/>
                                </div>
                                <div onClick={()=>{ palabrasClave.length > 0 ? saveEpisode() : 
                                    setError(true); 
                                    setErrorMessage("Motivo de la consula requerida");  
                                    setTimeout(() => {
                                      setError(false)
                                    }, 4000);
                                }} className={`btn ${ palabrasClave.length > 0 ? "btn-primary" : "btn-disabled"}`}>
                                    Guardar
                                </div>
                            </div>
                        :
                        /* Antecedentes*/
                        <div>
                            <div className="row no-gutters align-items-center justify-content-spacebetween">
                                <div className="row no-gutters align-items-center my-3">
                                    <p className="mb-0 col-lg-6">Nro. de CHIP:</p>
                                    <input value={anteAmbientalValues.chip} placeholder={ antecedentes === undefined ? "" : antecedentes.chip} onChange={(e)=>setAnteAmbientalValues({...anteAmbientalValues, chip: e.target.value})} className="form-control col-lg-6"/>
                                </div>
                                <div onClick={()=>{updateAntecedentes()}} className="btn btn-primary">
                                    Actualizar antecedentes
                                </div>
                            </div>
                            <div className="row ">
                                <div className="col-lg-6">
                                    <h4 className="my-3">Ambiental</h4>
                                    <div className="row no-gutters align-items-center my-3">
                                        <p className="mb-0 col-lg-6">Lugar de nacimiento</p>
                                        <input placeholder={antecedentes === undefined ? "" : antecedentes.lugarNacimiento} value={anteAmbientalValues.lugarNacimiento} onChange={(e)=>setAnteAmbientalValues({...anteAmbientalValues, lugarNacimiento: e.target.value})} className="form-control col-lg-6"/>
                                    </div>
                                    <div className="row no-gutters align-items-center my-3">
                                        <p className="mb-0 col-lg-6">Donde ha vivido</p>
                                        <input placeholder={antecedentes === undefined ? "" : antecedentes.dondeVivido} value={anteAmbientalValues.dondeVivido} onChange={(e)=>setAnteAmbientalValues({...anteAmbientalValues, dondeVivido: e.target.value})} className="form-control col-lg-6"/>
                                    </div>
                                    <div className="row no-gutters align-items-center my-3">
                                        <p className="mb-0 col-lg-6">Tipo de vivienda</p>
                                        <select value={anteAmbientalValues.tipoVivienda} onChange={(e)=>setAnteAmbientalValues({...anteAmbientalValues, tipoVivienda: e.target.value})} className="mt-3 form-control col-lg-6"  placeholder="W">
                                            { antecedentes !== undefined ? <option value={antecedentes.tipoVivienda}>{antecedentes.tipoVivienda}</option> : <option value=""></option>}
                                            { antecedentes !== undefined && antecedentes.tipoVivienda === "Callejero" ? <></> : <option value="Callejero">Callejero</option> }
                                            { antecedentes !== undefined && antecedentes.tipoVivienda === "Campo" ? <></> : <option value="Campo">Campo</option> }
                                            { antecedentes !== undefined && antecedentes.tipoVivienda === "Departamento" ? <></> : <option value="Departamento">Departamento</option> }
                                            { antecedentes !== undefined && antecedentes.tipoVivienda === "Callejero" ? <></> : <option value="Casa">Casa</option> }
                                            { antecedentes !== undefined && antecedentes.tipoVivienda === "Otro" ? <></> : <option value="Otro">Otro</option> }
                                        </select>
                                    </div>
                                    <div className="row no-gutters align-items-center my-3">
                                        <p className="mb-0 col-lg-6">Convivencia con otros animales</p>
                                        <input placeholder={antecedentes === undefined ? "" : antecedentes.convivenciaAnimales} value={anteAmbientalValues.convivenciaAnimales}onChange={(e)=>setAnteAmbientalValues({...anteAmbientalValues, convivenciaAnimales: e.target.value})} className="form-control col-lg-6"/>
                                    </div>
                                    <div className="row no-gutters align-items-center my-3">
                                        <p className="mb-0 col-lg-6">Actividad física</p>
                                        <select value={anteAmbientalValues.actividadFisica} onChange={(e)=>setAnteAmbientalValues({...anteAmbientalValues, actividadFisica: e.target.value})} className="mt-3 form-control col-lg-6"  placeholder="W">
                                            {antecedentes !== undefined ? <option value={antecedentes.actividadFisica}>{antecedentes.actividadFisica}</option> : <option value=""></option>}
                                            { antecedentes !== undefined && antecedentes.actividadFisica === "Sedentario" ? <></> : <option value="Sedentario">Sedentario</option> }
                                            { antecedentes !== undefined && antecedentes.actividadFisica === "Paseos" ? <></> : <option value="Paseos">Paseos</option> }
                                            { antecedentes !== undefined && antecedentes.actividadFisica === "Deportivo" ? <></> : <option value="Deportivo">Deportivo</option> }
                                            { antecedentes !== undefined && antecedentes.actividadFisica === "Entrenamiento" ? <></> : <option value="Entrenamiento">Entrenamiento</option> }
                                        </select>
                                    </div>

                                </div>
                                <div className="col-lg-6">
                                    <h4 className="my-3">Antecedentes familiares</h4>
                                    <div className="row">
                                        <p className="col-lg-6 mb-0"></p>
                                        <div className="row col-lg-6">
                                            <div className="col-lg-6 text-center">
                                                Padre
                                            </div>
                                            <div className="col-lg-6 text-center">
                                                Madre
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row no-gutters align-items-center my-3">
                                        <p className="col-lg-6 mb-0">Cáncer</p>
                                        <div className="row col-lg-6">
                                            <div className="col-lg-6 text-center">
                                                <input defaultChecked={antecedentes === undefined ? false : antecedentes.antePadresValues.cancerPadre} type="checkbox" onClick={()=>{ setAntePadresValues({...antePadresValues, cancerPadre: !antePadresValues.cancerPadre}) }}/>
                                            </div>
                                            <div className="col-lg-6 text-center">
                                                <input defaultChecked={antecedentes === undefined ? false : antecedentes.antePadresValues.cancerMadre} type="checkbox" onClick={()=>{ setAntePadresValues({...antePadresValues, cancerMadre: !antePadresValues.cancerMadre}) }}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row no-gutters align-items-center my-3">
                                        <p className="col-lg-6 mb-0">Diabetes</p>
                                        <div className="row col-lg-6">
                                            <div className="col-lg-6 text-center">
                                                <input defaultChecked={antecedentes === undefined ? false : antecedentes.antePadresValues.diabetesPadre} type="checkbox" onClick={()=>{ setAntePadresValues({...antePadresValues, diabetesPadre: !antePadresValues.diabetesPadre}) }}/>
                                            </div>
                                            <div className="col-lg-6 text-center">
                                                <input defaultChecked={antecedentes === undefined ? false : antecedentes.antePadresValues.diabetesMadre} type="checkbox" onClick={()=>{ setAntePadresValues({...antePadresValues, diabetesMadre: !antePadresValues.diabetesMadre}) }}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row no-gutters align-items-center my-3">
                                        <p className="col-lg-6 mb-0">Cardiopatías</p>
                                        <div className="row col-lg-6">
                                            <div className="col-lg-6 text-center">
                                                <input defaultChecked={antecedentes === undefined ? false : antecedentes.antePadresValues.cardiopatiasPadre} type="checkbox" onClick={()=>{ setAntePadresValues({...antePadresValues, cardiopatiasPadre: !antePadresValues.cardiopatiasPadre}) }}/>
                                            </div>
                                            <div className="col-lg-6 text-center">
                                                <input defaultChecked={antecedentes === undefined ? false : antecedentes.antePadresValues.cardiopatiasMadre} type="checkbox" onClick={()=>{ setAntePadresValues({...antePadresValues, cardiopatiasMadre: !antePadresValues.cardiopatiasMadre}) }}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row no-gutters align-items-center my-3">
                                        <p className="col-lg-6 mb-0">Aparato Locomotor</p>
                                        <div className="row col-lg-6">
                                            <div className="col-lg-6 text-center">
                                                <input defaultChecked={antecedentes === undefined ? false : antecedentes.antePadresValues.aparatoLocomotorPadre} type="checkbox" onClick={()=>{ setAntePadresValues({...antePadresValues, aparatoLocomotorPadre: !antePadresValues.aparatoLocomotorPadre}) }}/>
                                            </div>
                                            <div className="col-lg-6 text-center">
                                                <input defaultChecked={antecedentes === undefined ? false : antecedentes.antePadresValues.aparatoLocomotorMadre} type="checkbox" onClick={()=>{ setAntePadresValues({...antePadresValues, aparatoLocomotorMadre: !antePadresValues.aparatoLocomotorMadre}) }} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row no-gutters align-items-center my-3">
                                        <p className="col-lg-6 mb-0">Sistema Nervioso</p>
                                        <div className="row col-lg-6">
                                            <div className="col-lg-6 text-center">
                                                <input defaultChecked={antecedentes === undefined ? false : antecedentes.antePadresValues.sistemaNerviosoPadre} type="checkbox" onClick={()=>{ setAntePadresValues({...antePadresValues, sistemaNerviosoPadre: !antePadresValues.sistemaNerviosoPadre}) }} />
                                            </div>
                                            <div className="col-lg-6 text-center">
                                                <input defaultChecked={antecedentes === undefined ? false : antecedentes.antePadresValues.sistemaNerviosoMadre} type="checkbox" onClick={()=>{ setAntePadresValues({...antePadresValues, sistemaNerviosoMadre: !antePadresValues.sistemaNerviosoMadre}) }} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row no-gutters align-items-center my-3">
                                        <p className="col-lg-6 mb-0">Otras</p>
                                        <input placeholder={antecedentes === undefined ? "" : antecedentes.antePadresValues.otras} value={antePadresValues.otras} onChange={(e)=>setAntePadresValues({...antePadresValues, otras: e.target.value})} className="form-control col-lg-6"/>
                                    </div>

                                </div>
                                <div className="col-lg-6">
                                    <h4 className="my-3">Fisiológicos</h4>
                                    <div className="row no-gutters align-items-center my-3">
                                        <p className="mb-0 col-lg-6">Toma de agua (Cantidad) </p>
                                        <select className="mt-3 form-control col-lg-6" value={anteFisiologicosValues.tomaAgua} onChange={(e)=>setAnteFisiologicosValues({...anteFisiologicosValues, tomaAgua: e.target.value})}>
                                            { antecedentes !== undefined ? <option value={antecedentes.anteFisiologicosValues.tomaAgua}>{antecedentes.anteFisiologicosValues.tomaAgua}</option> : <option value=""></option>}
                                            { antecedentes !== undefined && antecedentes.anteFisiologicosValues.tomaAgua === "1/2 litro" ? <></> : <option value="1/2 litro">1/2 litro</option>}
                                            { antecedentes !== undefined && antecedentes.anteFisiologicosValues.tomaAgua === "1 litro" ? <></> : <option value="1 litro">1 litro</option>}
                                            { antecedentes !== undefined && antecedentes.anteFisiologicosValues.tomaAgua === "2 litros" ? <></> : <option value="2 litros">2 litros</option>}
                                            { antecedentes !== undefined && antecedentes.anteFisiologicosValues.tomaAgua === "3 litros" ? <></> : <option value="3 litros">3 litros</option>}
                                        </select>
                                    </div>
                                    <div className="row no-gutters align-items-center my-3">
                                        <p className="mb-0 col-lg-6">Evacuaciones</p>
                                        <select className="mt-3 form-control col-lg-6" value={anteFisiologicosValues.defecacion} onChange={(e)=>setAnteFisiologicosValues({...anteFisiologicosValues, defecacion: e.target.value})}>
                                            { antecedentes !== undefined ? <option value={antecedentes.anteFisiologicosValues.defecacion}>{antecedentes.anteFisiologicosValues.defecacion}</option> : <option value=""></option>}
                                            { antecedentes !== undefined && antecedentes.anteFisiologicosValues.defecacion === "1 vez" ? <></> : <option value="1 vez">1 vez</option> }
                                            { antecedentes !== undefined && antecedentes.anteFisiologicosValues.defecacion === "2 veces" ? <></> : <option value="2 veces">2 veces</option> }
                                            { antecedentes !== undefined && antecedentes.anteFisiologicosValues.defecacion === "3 veces" ? <></> : <option value="3 veces">3 veces</option> }
                                            { antecedentes !== undefined && antecedentes.anteFisiologicosValues.defecacion === "4 veces" ? <></> : <option value="4 veces">4 veces</option> }
                                            { antecedentes !== undefined && antecedentes.anteFisiologicosValues.defecacion === "5 veces" ? <></> : <option value="5 veces">5 veces</option> }
                                            { antecedentes !== undefined && antecedentes.anteFisiologicosValues.defecacion === "6 veces" ? <></> : <option value="6 veces">6 veces</option> }
                                            { antecedentes !== undefined && antecedentes.anteFisiologicosValues.defecacion === "mas" ? <></> : <option value="mas">más</option> }
                                        </select>
                                    </div>
                                    <div className="row no-gutters align-items-center my-3">
                                        <p className="mb-0 col-lg-6">Micción</p>
                                        <select className="mt-3 form-control col-lg-6" value={anteFisiologicosValues.diuresis} onChange={(e)=>setAnteFisiologicosValues({...anteFisiologicosValues, diuresis: e.target.value})}>
                                            { antecedentes !== undefined ? <option value={antecedentes.anteFisiologicosValues.diuresis}>{antecedentes.anteFisiologicosValues.diuresis}</option> : <option value=""></option>}
                                            { antecedentes !== undefined && antecedentes.anteFisiologicosValues.diuresis === "1 vez" ? <></> : <option value="1 vez">1 vez</option> }
                                            { antecedentes !== undefined && antecedentes.anteFisiologicosValues.diuresis === "2 veces" ? <></> : <option value="2 veces">2 veces</option> }
                                            { antecedentes !== undefined && antecedentes.anteFisiologicosValues.diuresis === "3 veces" ? <></> : <option value="3 veces">3 veces</option> }
                                            { antecedentes !== undefined && antecedentes.anteFisiologicosValues.diuresis === "4 veces" ? <></> : <option value="4 veces">4 veces</option> }
                                            { antecedentes !== undefined && antecedentes.anteFisiologicosValues.diuresis === "5 veces" ? <></> : <option value="5 veces">5 veces</option> }
                                            { antecedentes !== undefined && antecedentes.anteFisiologicosValues.diuresis === "6 veces" ? <></> : <option value="6 veces">6 veces</option> }
                                            { antecedentes !== undefined && antecedentes.anteFisiologicosValues.diuresis === "mas" ? <></> : <option value="mas">más</option> }
                                        </select>
                                    </div>
                                    <div className="row no-gutters align-items-center my-3">
                                        <p className="mb-0 col-lg-6">Sueño (Cantidad de horas) </p>
                                        <input placeholder={antecedentes === undefined ? "" : antecedentes.anteFisiologicosValues.sueno} className="form-control col-lg-6" value={anteFisiologicosValues.sueno} onChange={(e)=>setAnteFisiologicosValues({...anteFisiologicosValues, sueno: e.target.value})}/>
                                    </div>
                                    {anteFisiologicosValues.sueno > 20 ? <p className="text-danger">Ingresa una cantidad correcta</p> : <></>}
                                    {pet.sexo === "Hembra" && <div className="row no-gutters align-items-center my-3">
                                        <p className="mb-0 col-lg-3">Fecha de último estro o celo</p>
                                        <div className="col-lg-3 text-center">
                                          <input type="checkbox" onClick={()=>{}} name=""/>
                                        </div>
                                        <div className="col-lg-6 spe-input">
                                          <DatePicker
                                            className="col-lg-12"
                                            format="ddd, MMM D YYYY"
                                            placeholder={todayDate}
                                            maxDate={moment().toDate()}
                                            label=""
                                            okLabel="Listo"
                                            cancelLabel="Cancelar"
                                            value={fechaPatologia}
                                            onChange={setFechaPatologia}
                                            animateYearScrolling
                                          />
                                        </div>
                                    </div> }
                                    {pet.sexo === "Hembra" &&   <div className="row no-gutters align-items-center my-3">
                                        <p className="mb-0 col-lg-6">Frecuencia en intensidad de celos</p>
                                        <select className=" form-control col-lg-6" value={anteFisiologicosValues.frecuenciaCelos} onChange={(e)=>setAnteFisiologicosValues({...anteFisiologicosValues, frecuenciaCelos: e.target.value})}>
                                            <option value="Poco">Poco</option>
                                            <option value="Normal">Normal</option>
                                            <option value="Mucho">Mucho</option>
                                        </select>
                                    </div> }
                                    <div className="row no-gutters align-items-center my-3">
                                        <p className="mb-0 col-lg-3">{pet.sexo === "Hembra" ?  "Esterilización" : "Castración"}</p>
                                        <div className="col-lg-3 text-center">
                                          <input type="checkbox" defaultChecked={antecedentes === undefined ? false : antecedentes.anteFisiologicosValues.castracion} onClick={()=>{ setAnteFisicoValues({...anteFisicoValues, castracion: !anteFisicoValues.castracion }) }}/>
                                        </div>
                                        <div className="col-lg-6 spe-input">
                                          <DatePicker
                                            className="col-lg-12"
                                            format="ddd, MMM D YYYY"
                                            placeholder={antecedentes === undefined ? todayDate : antecedentes.anteFisiologicosValues.castracionFecha }
                                            maxDate={moment().toDate()}
                                            label=""
                                            okLabel="Listo"
                                            cancelLabel="Cancelar"
                                            value={castracionFecha}
                                            onChange={setCastracionFecha}
                                            animateYearScrolling
                                          />
                                        </div>
                                    </div>
                                    <div className="row no-gutters align-items-center my-3">
                                        <p className="mb-0 col-lg-6">Cirugia estética</p>
                                        <input placeholder={antecedentes === undefined ? "" : antecedentes.anteFisiologicosValues.cirugiaEstetica} className="form-control col-lg-6" value={anteFisiologicosValues.cirugiaEstetica} onChange={(e)=>setAnteFisiologicosValues({...anteFisiologicosValues, cirugiaEstetica: e.target.value})}/>
                                    </div>
                                    <div className="row no-gutters align-items-center my-3">
                                        <p className="mb-0 col-lg-6">Comentarios cirugia estética</p>
                                        <input placeholder={antecedentes === undefined ? "" : antecedentes.anteFisiologicosValues.comentarioCirugia} className="form-control col-lg-6" value={anteFisiologicosValues.comentarioCirugia} onChange={(e)=>setAnteFisiologicosValues({...anteFisiologicosValues, comentarioCirugia: e.target.value})}/>
                                    </div>
                                    {pet.sexo === "Hembra" &&  
                                        <>
                                        <div className="row no-gutters align-items-center my-3">
                                        <p className="mb-0 col-lg-6">Fecha de último parto</p>
                                        <div className="col-lg-6 spe-input">
                                          <DatePicker
                                            className="col-lg-12"
                                            format="ddd, MMM D YYYY"
                                            placeholder={todayDate}
                                            maxDate={moment().toDate()}
                                            label=""
                                            okLabel="Listo"
                                            cancelLabel="Cancelar"
                                            value={fechaPatologia}
                                            onChange={setFechaPatologia}
                                            animateYearScrolling
                                          />
                                        </div>
                                        </div>
                                        <div className="row no-gutters align-items-center my-3">
                                            <p className="mb-0 col-lg-6">Ha quedado preñada (gestante)</p>
                                            <input className="form-control col-lg-6" value={anteFisiologicosValues.gestante} onChange={(e)=>setAnteFisiologicosValues({...anteFisiologicosValues, gestante: e.target.value})}/>
                                        </div>
                                        <div className="row no-gutters align-items-center my-3">
                                            <p className="mb-0 col-lg-6">Cuantos partos ha tenido</p>
                                            <input className="form-control col-lg-6" value={anteFisiologicosValues.cuantosPartos} onChange={(e)=>setAnteFisiologicosValues({...anteFisiologicosValues, cuantosPartos: e.target.value})}/>
                                        </div>
                                        <div className="row no-gutters align-items-center my-3">
                                            <p className="mb-0 col-lg-6">Tiempo de duración (días)</p>
                                            <input className="form-control col-lg-6" value={anteFisiologicosValues.tipoDuracionPartos} onChange={(e)=>setAnteFisiologicosValues({...anteFisiologicosValues, tipoDuracionPartos: e.target.value})}/>
                                        </div>
                                        </>
                                    }
                                </div>
                                <div className="col-lg-6">
                                    <h4 className="my-3">Alimenticio</h4>
                                    <div className="row no-gutters align-items-center my-3">
                                        <p className="mb-0 col-lg-6">Tipo de alimentación</p>
                                        <select value={anteAlimenticioValues.tipoAlimenticio} onChange={(e)=>setAnteAlimenticioValues({...anteAlimenticioValues, tipoAlimenticio: e.target.value})} className="mt-3 form-control col-lg-6"  placeholder="W">
                                            { antecedentes !== undefined ? <option value={antecedentes.anteAlimenticioValues.tipoAlimenticio}>{antecedentes.anteAlimenticioValues.tipoAlimenticio}</option> : <option value=""></option>}
                                            { antecedentes !== undefined && antecedentes.anteAlimenticioValues.tipoAlimenticio === "Barf" ? <></> : <option value="Barf">Barf</option>}
                                            { antecedentes !== undefined && antecedentes.anteAlimenticioValues.tipoAlimenticio === "Concentrados" ? <></> : <option value="Concentrados">Concentrados</option>}
                                            { antecedentes !== undefined && antecedentes.anteAlimenticioValues.tipoAlimenticio === "Seco y humedo" ? <></> : <option value="Seco y humedo">Seco y húmedo</option>}
                                            { antecedentes !== undefined && antecedentes.anteAlimenticioValues.tipoAlimenticio === "Casera" ? <></> : <option value="Casera">Casera</option>}
                                        </select>
                                    </div>
                                    { anteAlimenticioValues.tipoAlimenticio !== "Casera" || antecedentes.anteAlimenticioValues.tipoAlimenticio !== "Casera" ?
                                        <div className="row no-gutters align-items-center my-3">
                                            <p className="mb-0 col-lg-6">Marca y tipo de alimento</p>
                                            <div className="row no-gutters col-lg-6">
                                                <input type="text" placeholder={ antecedentes === undefined ? "Marca y tipo de alimento" : antecedentes.anteAlimenticioValues.marca} value={anteAlimenticioValues.marca} onChange={(e)=>setAnteAlimenticioValues({...anteAlimenticioValues, marca: e.target.value})} className="mt-3 form-control col-lg-12" />
                                            </div>
                                        </div>
                                     :
                                        <div className="row no-gutters align-items-center my-3">
                                            <p className="mb-0 col-lg-6">Casera</p>
                                            <input value={anteAlimenticioValues.cacera} placeholder={antecedentes === undefined ? "Describe lo que le ofreces" : antecedentes.anteAlimenticioValues.cacera} onChange={(e)=>setAnteAlimenticioValues({...anteAlimenticioValues, cacera: e.target.value})} className="form-control col-lg-6"/>
                                        </div>
                                    }
                                    <div className="row no-gutters align-items-center my-3">
                                        <p className="mb-0 col-lg-6">Cantidad (gr) y frecuencia diaria</p>
                                        <div className="row no-gutters col-lg-6">
                                            <div className="col-lg-6">
                                                <input type="text" placeholder={antecedentes === undefined ? "Cantidad" : antecedentes.anteAlimenticioValues.cantidad} value={anteAlimenticioValues.cantidad} onChange={(e)=>setAnteAlimenticioValues({...anteAlimenticioValues, cantidad: e.target.value})} className="mt-3 form-control col-lg-12" />
                                            </div>
                                            <div className="col-lg-6">
                                                <select value={anteAlimenticioValues.frecuencia} onChange={(e)=>setAnteAlimenticioValues({...anteAlimenticioValues, frecuencia: e.target.value})} className="mt-3 form-control col-lg-12"  placeholder="W">
                                                    { antecedentes !== undefined ? <option value={antecedentes.anteAlimenticioValues.frecuencia}>{antecedentes.anteAlimenticioValues.frecuencia}</option> : <option value=""></option>}
                                                    { antecedentes !== undefined && antecedentes.anteAlimenticioValues.frecuencia === "1 vez" ? <></> : <option value="1 vez">1 vez</option> }
                                                    { antecedentes !== undefined && antecedentes.anteAlimenticioValues.frecuencia === "2 veces" ? <></> : <option value="2 veces">2 veces</option> }
                                                    { antecedentes !== undefined && antecedentes.anteAlimenticioValues.frecuencia === "3 veces" ? <></> : <option value="3 veces">3 veces</option> }
                                                    { antecedentes !== undefined && antecedentes.anteAlimenticioValues.frecuencia === "4 veces" ? <></> : <option value="4 veces">4 veces</option> }
                                                    { antecedentes !== undefined && antecedentes.anteAlimenticioValues.frecuencia === "Mas de 4 veces" ? <></> : <option value="Mas de 4 veces">Más de 4 veces</option> }
                                                </select>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        /* End Antecedentes*/
                        }
                    </div>
                    {/* End General */}
                    {/* Antecedentes y otros episodios */}
                    <div className="col-lg-4">
                        <div className={antecedentesStatus || antecedentes === undefined ? "d-none" : "antecedentes-box"}>
                            <div className="antecedentes-box-title">
                                Antecedentes
                            </div>
                            <div className="antecedentes-box-p">
                                {antecedentes !== undefined ? "Lugar de nacimiento: " + antecedentes.lugarNacimiento : ""}
                            </div>
                            {/* <div className="antecedentes-box-p">
                                Ha vivido con único dueño
                            </div> */}
                            <div className="antecedentes-box-p">
                                {antecedentes !== undefined ? "Tipo de vivienda: " + antecedentes.tipoVivienda : ""}
                            </div>
                            <div className="antecedentes-box-p">
                                {antecedentes !== undefined ? "Convivencia con animales: " + antecedentes.convivenciaAnimales : ""}
                            </div>
                            <div className="antecedentes-box-p">
                                {antecedentes !== undefined ? "Actividad física: " + antecedentes.actividadFisica : ""}
                            </div>
                            <div onClick={()=>{setEpisodioStatus(false); setEventoStatus(false); setAntecedentesStatus(true)}} className="btn btn-block btn-outline-primary">
                                Ver
                            </div>
                        </div>
                        { episodios.length > 0 && !antecedentesStatus ? <div className="mt-4 episodes-scroll-wrapper">
                            {episodios.map((epi)=>{
                                let date = moment(epi.fechaConsulta.toDate()).format("ddd, MMM D YYYY").toString()
                                return(
                                    <div className="episodes-container" key={epi.idConsulta}>
                                        <div className="episode-header">{date}</div>
                                        <div className="episode-body">
                                            <p className="episode-title">Motivo de la consulta:</p>
                                            <div className="row no-gutters">
                                                {epi.motivoConsulta.map((mc)=>{
                                                    return (
                                                        <p className="pill-2">{mc}</p>
                                                    )
                                                })}
                                            </div>
                                            { epi.instruccionesAdicionalesConsulta && <p className="episode-title">Recomendaciones:</p>}
                                            <p className="episode-text">{epi.instruccionesAdicionalesConsulta}</p>
                                            <div onClick={()=>{setEpisodeShow(true); setEpisode(epi)}} className="btn btn-block btn-outline-primary">
                                                Ver
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div> : <div></div> }
                    </div>
                    {/* End antecedentes y otros episodios */}
                </div>
            </div>

        </div>
    </MuiPickersUtilsProvider>
    )
    
    async function saveEpisode(){
        let id = Date.now().toString()
        try{
            await firebase.db.collection("Expedientes").doc(data.state.mid).collection("Episodios").doc(id).set({
                idConsulta: id,
                fechaConsulta: fechaConsulta ? fechaConsulta.toDate() : moment().toDate(),
                signosVitales: valores,
                signosVitalesFechas: [ 
                    fechaPeso ? fechaPeso.toDate() : moment().toDate(),
                    fechaTemperatura ? fechaTemperatura.toDate() : moment().toDate(),
                    fechaFrecuenciaResp ? fechaFrecuenciaResp.toDate() : moment().toDate(),
                    fechaFrecuenciaCard ? fechaFrecuenciaCard.toDate() : moment().toDate(),
                    fechaPresionArterial ? fechaPresionArterial.toDate() : moment().toDate(),
                ],
                motivoConsulta: palabrasClave,
                anteFisicoValues,
                anteAparatosValues,
                ordenesEstudio,
                tratamientos,
                detalleConsulta: episodioValues.detalleConsulta,
                diagnosticoConsulta: episodioValues.diagnosticoConsulta,
                comentariosConsulta: episodioValues.comentariosConsulta,
                instruccionesAdicionalesConsulta: episodioValues.instruccionesAdicionalesConsulta
            }).then((val)=>{
                setListoConsulta(true)
                // setSucessMessage("Consulta creada exitosamente")
                // setSuccess(true)
            })
        }catch(e){
            console.log(e)
        }
    }
    
    async function updateAntecedentes(){
        let id = Date.now().toString()
        anteFisiologicosValues["castracionFecha"] = moment( castracionFecha && castracionFecha.toDate()).format("ddd, MMM D YYYY").toString()
        try{
            await firebase.db.collection("Expedientes").doc(data.state.mid).collection("Antecedentes").doc(data.state.mid).get().then((doc)=>{
                firebase.db.collection("Expedientes").doc(data.state.mid).collection("Antecedentes").doc(data.state.mid).set({
                    chip: doc.exists && anteAmbientalValues.chip === "" ? doc.data().chip : anteAmbientalValues.chip,
                    lugarNacimiento: doc.exists && anteAmbientalValues.lugarNacimiento === "" ? doc.data().lugarNacimiento : anteAmbientalValues.lugarNacimiento,
                    dondeVivido: doc.exists && anteAmbientalValues.dondeVivido === "" ? doc.data().dondeVivido : anteAmbientalValues.dondeVivido,
                    tipoVivienda: doc.exists && anteAmbientalValues.tipoVivienda === "" ? doc.data().tipoVivienda : anteAmbientalValues.tipoVivienda,
                    convivenciaAnimales: doc.exists && anteAmbientalValues.convivenciaAnimales === "" ? doc.data().convivenciaAnimales : anteAmbientalValues.convivenciaAnimales,
                    actividadFisica: doc.exists && anteAmbientalValues.actividadFisica === "" ? doc.data().actividadFisica : anteAmbientalValues.actividadFisica,
                    anteFisiologicosValues: {                        
                        castracion: doc.exists && anteFisiologicosValues.castracion === doc.data().anteFisiologicosValues.castracion ? doc.data().anteFisiologicosValues.castracion : anteFisiologicosValues.castracion ,
                        castracionFecha: doc.exists && anteFisiologicosValues.castracionFecha === "" ? doc.data().anteFisiologicosValues.castracionFecha : anteFisiologicosValues.castracionFecha ,
                        cirugiaEstetica: doc.exists && anteFisiologicosValues.cirugiaEstetica === "" ? doc.data().anteFisiologicosValues.cirugiaEstetica : anteFisiologicosValues.cirugiaEstetica ,
                        comentarioCirugia: doc.exists && anteFisiologicosValues.comentarioCirugia === "" ? doc.data().anteFisiologicosValues.comentarioCirugia : anteFisiologicosValues.comentarioCirugia ,
                        cuantosPartos: doc.exists && anteFisiologicosValues.cuantosPartos === "" ? doc.data().anteFisiologicosValues.cuantosPartos : anteFisiologicosValues.cuantosPartos ,
                        defecacion: doc.exists && anteFisiologicosValues.defecacion === "" ? doc.data().anteFisiologicosValues.defecacion : anteFisiologicosValues.defecacion ,
                        diuresis: doc.exists && anteFisiologicosValues.diuresis === "" ? doc.data().anteFisiologicosValues.diuresis : anteFisiologicosValues.diuresis ,
                        fechaUltimoEstrogeno: doc.exists && anteFisiologicosValues.fechaUltimoEstrogeno === "" ? doc.data().anteFisiologicosValues.fechaUltimoEstrogeno : anteFisiologicosValues.fechaUltimoEstrogeno ,
                        frecuenciaCelos: doc.exists && anteFisiologicosValues.frecuenciaCelos === "" ? doc.data().anteFisiologicosValues.frecuenciaCelos : anteFisiologicosValues.frecuenciaCelos ,
                        gestante: doc.exists && anteFisiologicosValues.gestante === "" ? doc.data().anteFisiologicosValues.gestante : anteFisiologicosValues.gestante ,
                        sueno: doc.exists && anteFisiologicosValues.sueno === doc.data().anteFisiologicosValues.sueno ? doc.data().anteFisiologicosValues.sueno : anteFisiologicosValues.sueno ,
                        tipoDuracionPartos: doc.exists && anteFisiologicosValues.tipoDuracionPartos === "" ? doc.data().anteFisiologicosValues.tipoDuracionPartos : anteFisiologicosValues.tipoDuracionPartos ,
                        tomaAgua: doc.exists && anteFisiologicosValues.tomaAgua === "" ? doc.data().anteFisiologicosValues.tomaAgua : anteFisiologicosValues.tomaAgua ,
                    },
                    anteAlimenticioValues: {
                        cacera: doc.exists && anteAlimenticioValues.cacera === "" ? doc.data().anteAlimenticioValues.cacera : anteAlimenticioValues.cacera  ,
                        cantidad: doc.exists && anteAlimenticioValues.cantidad === "" ? doc.data().anteAlimenticioValues.cantidad : anteAlimenticioValues.cantidad  ,
                        frecuencia: doc.exists && anteAlimenticioValues.frecuencia === "" ? doc.data().anteAlimenticioValues.frecuencia : anteAlimenticioValues.frecuencia  ,
                        marca: doc.exists && anteAlimenticioValues.marca === "" ? doc.data().anteAlimenticioValues.marca : anteAlimenticioValues.marca  ,
                        tipoAlimenticio: doc.exists && anteAlimenticioValues.tipoAlimenticio === "" ? doc.data().anteAlimenticioValues.tipoAlimenticio : anteAlimenticioValues.tipoAlimenticio  ,
                        tipoAlimento: doc.exists && anteAlimenticioValues.tipoAlimento === "" ? doc.data().anteAlimenticioValues.tipoAlimento : anteAlimenticioValues.tipoAlimento,
                    },
                    antePadresValues: {
                        cancerMadre: doc.exists && antePadresValues.cancerMadre === doc.data().antePadresValues.cancerMadre ? doc.data().antePadresValues.cancerMadre : antePadresValues.cancerMadre ,
                        diabetesMadre: doc.exists && antePadresValues.diabetesMadre === doc.data().antePadresValues.diabetesMadre ? doc.data().antePadresValues.diabetesMadre : antePadresValues.diabetesMadre ,
                        cardiopatiasMadre: doc.exists && antePadresValues.cardiopatiasMadre === doc.data().antePadresValues.cardiopatiasMadre ? doc.data().antePadresValues.cardiopatiasMadre : antePadresValues.cardiopatiasMadre ,
                        aparatoLocomotorMadre: doc.exists && antePadresValues.aparatoLocomotorMadre === doc.data().antePadresValues.aparatoLocomotorMadre ? doc.data().antePadresValues.aparatoLocomotorMadre : antePadresValues.aparatoLocomotorMadre ,
                        sistemaNerviosoMadre: doc.exists && antePadresValues.sistemaNerviosoMadre === doc.data().antePadresValues.sistemaNerviosoMadre ? doc.data().antePadresValues.sistemaNerviosoMadre : antePadresValues.sistemaNerviosoMadre ,
                        cancerPadre: doc.exists && antePadresValues.cancerPadre === doc.data().antePadresValues.cancerPadre ? doc.data().antePadresValues.cancerPadre : antePadresValues.cancerPadre ,
                        diabetesPadre: doc.exists && antePadresValues.diabetesPadre === doc.data().antePadresValues.diabetesPadre ? doc.data().antePadresValues.diabetesPadre : antePadresValues.diabetesPadre ,
                        cardiopatiasPadre: doc.exists && antePadresValues.cardiopatiasPadre === doc.data().antePadresValues.cardiopatiasPadre ? doc.data().antePadresValues.cardiopatiasPadre : antePadresValues.cardiopatiasPadre ,
                        aparatoLocomotorPadre: doc.exists && antePadresValues.aparatoLocomotorPadre === doc.data().antePadresValues.aparatoLocomotorPadre ? doc.data().antePadresValues.aparatoLocomotorPadre : antePadresValues.aparatoLocomotorPadre ,
                        sistemaNerviosoPadre: doc.exists && antePadresValues.sistemaNerviosoPadre === doc.data().antePadresValues.sistemaNerviosoPadre ? doc.data().antePadresValues.sistemaNerviosoPadre : antePadresValues.sistemaNerviosoPadre ,
                        otras: doc.exists && antePadresValues.otras === "" ? doc.data().antePadresValues.otras : antePadresValues.otras,
                    }
                }).then((val)=>{
                    setSucessMessage("Antecedentes actualizados exitosamente")
                    setSuccess(true)
                    setTimeout(() => {
                      setSuccess(false)
                    }, 4000);
                })
            })
        }catch(e){
            console.log(e)
        }
    }

    async function saveGeneral(type){
        let id = Date.now().toString()
        try {
            switch (type) {
                case "a":
                    await firebase.db.collection("Expedientes").doc(data.state.mid).collection("Peso").doc(id).set({
                        eid: id,
                        fechaPeso: fechaPeso !== null ? fechaPeso.toDate() : moment().toDate(),
                        peso: parseInt(valores.peso),
                        mid: data.state.mid,
                    }).then((val)=>{
                        setSucessMessage("Peso guardado exitosamente")
                        setSuccess(true)
                        setTimeout(() => {
                          setSuccess(false)
                        }, 4000);
                        getPet(data.state.mid)
                    })
                    break;
                case "b":
                    await firebase.db.collection("Expedientes").doc(data.state.mid).collection("Temperatura").doc(id).set({
                        eid: id,
                        fechaTemperatura: fechaTemperatura !== null ? fechaTemperatura.toDate() : moment().toDate(),
                        temperatura: parseInt(valores.temperatura),
                        mid: data.state.mid,
                    }).then((val)=>{
                        setSucessMessage("Temperatura guardada exitosamente")
                        setSuccess(true)
                        setTimeout(() => {
                          setSuccess(false)
                        }, 4000);
                        getPet(data.state.mid)
                    })
                    break;
                case "c":
                    await firebase.db.collection("Expedientes").doc(data.state.mid).collection("Esterilizacion").doc(id).set({
                        eid: id,
                        fechaEsteril: fechaCastrado !== null ? fechaCastrado.toDate() : moment().toDate(),
                        esteril: valores.castrado,
                        mid: data.state.mid,
                    }).then((val)=>{
                        setSucessMessage("Esterilización guardada exitosamente")
                        setSuccess(true)
                        setTimeout(() => {
                          setSuccess(false)
                        }, 4000);
                        getPet(data.state.mid)
                    })
                    break;
                case "d":
                    await firebase.db.collection("Expedientes").doc(data.state.mid).collection("Desparasitacion").doc(id).set({
                        eid: id,
                        fechaDesparasitacion: fechaDesparacitacion !== null ? fechaDesparacitacion.toDate() : moment().toDate(),
                        mid: data.state.mid,
                    }).then((val)=>{
                        setSucessMessage("Desparasitación guardada exitosamente")
                        setSuccess(true)
                        setTimeout(() => {
                          setSuccess(false)
                        }, 4000);
                        getPet(data.state.mid)
                    })
                    break;
                case "e":
                    await firebase.db.collection("Expedientes").doc(data.state.mid).collection("Vacunas").doc(id).set({
                        eid: id,
                        fechaVacuna: fechaVacunas !== null ? fechaVacunas.toDate() : moment().toDate(),
                        vacuna: valores.vacuna,
                        mid: data.state.mid,
                    }).then((val)=>{
                        setSucessMessage("Vacuna guardada exitosamente")
                        setSuccess(true)
                        setTimeout(() => {
                          setSuccess(false)
                        }, 4000);
                        getPet(data.state.mid)
                    })
                    break;
                case "f":
                    await firebase.db.collection("Expedientes").doc(data.state.mid).collection("Alergias").doc(id).set({
                        eid: id,
                        fechaAlergia: fechaAlergias !== null ? fechaAlergias.toDate() : moment().toDate(),
                        alergia: valores.alergia,
                        mid: data.state.mid,
                    }).then((val)=>{
                        setSucessMessage("Alergia guardada exitosamente")
                        setSuccess(true)
                        setTimeout(() => {
                          setSuccess(false)
                        }, 4000);
                        getPet(data.state.mid)
                    })
                    break;
                case "g":
                    await firebase.db.collection("Expedientes").doc(data.state.mid).collection("Patologia").doc(id).set({
                        eid: id,
                        fechaPatologia: fechaPatologia !== null ? fechaPatologia.toDate() : moment().toDate(),
                        patologia: valores.patologia,
                        mid: data.state.mid,
                    }).then((val)=>{
                        setSucessMessage("Patología guardada exitosamente")
                        setSuccess(true)
                        setTimeout(() => {
                          setSuccess(false)
                        }, 4000);
                        getPet(data.state.mid)
                    })
                    break;
                default:
                    break;
            }
        } catch (e) {
            console.log(`Error: ${e.message}`)
        }
    }


}

export default History